var map = {
	"./0-circle-fill.svg": [
		8494,
		8494
	],
	"./0-circle.svg": [
		13840,
		13840
	],
	"./0-square-fill.svg": [
		4454,
		4454
	],
	"./0-square.svg": [
		5531,
		5531
	],
	"./1-circle-fill.svg": [
		47333,
		47333
	],
	"./1-circle.svg": [
		67190,
		67190
	],
	"./1-square-fill.svg": [
		85512,
		85512
	],
	"./1-square.svg": [
		44406,
		44406
	],
	"./123.svg": [
		13598,
		13598
	],
	"./2-circle-fill.svg": [
		89423,
		89423
	],
	"./2-circle.svg": [
		33592,
		33592
	],
	"./2-square-fill.svg": [
		99487,
		99487
	],
	"./2-square.svg": [
		51007,
		51007
	],
	"./3-circle-fill.svg": [
		76146,
		76146
	],
	"./3-circle.svg": [
		49618,
		49618
	],
	"./3-square-fill.svg": [
		9859,
		9859
	],
	"./3-square.svg": [
		32948,
		32948
	],
	"./4-circle-fill.svg": [
		85278,
		85278
	],
	"./4-circle.svg": [
		99199,
		99199
	],
	"./4-square-fill.svg": [
		72970,
		72970
	],
	"./4-square.svg": [
		13450,
		13450
	],
	"./5-circle-fill.svg": [
		93398,
		93398
	],
	"./5-circle.svg": [
		57306,
		57306
	],
	"./5-square-fill.svg": [
		743,
		743
	],
	"./5-square.svg": [
		97421,
		97421
	],
	"./6-circle-fill.svg": [
		32234,
		32234
	],
	"./6-circle.svg": [
		87501,
		87501
	],
	"./6-square-fill.svg": [
		60778,
		60778
	],
	"./6-square.svg": [
		50657,
		50657
	],
	"./7-circle-fill.svg": [
		76283,
		76283
	],
	"./7-circle.svg": [
		48437,
		48437
	],
	"./7-square-fill.svg": [
		91190,
		91190
	],
	"./7-square.svg": [
		58045,
		58045
	],
	"./8-circle-fill.svg": [
		98888,
		98888
	],
	"./8-circle.svg": [
		25298,
		25298
	],
	"./8-square-fill.svg": [
		60551,
		60551
	],
	"./8-square.svg": [
		13646,
		13646
	],
	"./9-circle-fill.svg": [
		36387,
		36387
	],
	"./9-circle.svg": [
		10385,
		10385
	],
	"./9-square-fill.svg": [
		54977,
		54977
	],
	"./9-square.svg": [
		25174,
		25174
	],
	"./activity.svg": [
		59755,
		59755
	],
	"./airplane-engines-fill.svg": [
		74078,
		74078
	],
	"./airplane-engines.svg": [
		26634,
		26634
	],
	"./airplane-fill.svg": [
		11047,
		11047
	],
	"./airplane.svg": [
		40669,
		40669
	],
	"./alarm-fill.svg": [
		21446,
		21446
	],
	"./alarm.svg": [
		6297,
		6297
	],
	"./alexa.svg": [
		64631,
		64631
	],
	"./align-bottom.svg": [
		86713,
		86713
	],
	"./align-center.svg": [
		30714,
		30714
	],
	"./align-end.svg": [
		59479,
		59479
	],
	"./align-middle.svg": [
		58172,
		58172
	],
	"./align-start.svg": [
		50874,
		50874
	],
	"./align-top.svg": [
		64183,
		64183
	],
	"./alipay.svg": [
		31298,
		31298
	],
	"./alphabet-uppercase.svg": [
		1932,
		1932
	],
	"./alphabet.svg": [
		9671,
		9671
	],
	"./alt.svg": [
		17195,
		17195
	],
	"./amazon.svg": [
		14046,
		14046
	],
	"./amd.svg": [
		70269,
		70269
	],
	"./android.svg": [
		76602,
		76602
	],
	"./android2.svg": [
		82702,
		82702
	],
	"./app-indicator.svg": [
		85359,
		85359
	],
	"./app.svg": [
		67949,
		67949
	],
	"./apple.svg": [
		27969,
		27969
	],
	"./archive-fill.svg": [
		32729,
		32729
	],
	"./archive.svg": [
		72594,
		72594
	],
	"./arrow-90deg-down.svg": [
		32844,
		32844
	],
	"./arrow-90deg-left.svg": [
		53210,
		53210
	],
	"./arrow-90deg-right.svg": [
		93896,
		93896
	],
	"./arrow-90deg-up.svg": [
		64831,
		64831
	],
	"./arrow-bar-down.svg": [
		77820,
		77820
	],
	"./arrow-bar-left.svg": [
		68761,
		68761
	],
	"./arrow-bar-right.svg": [
		17977,
		17977
	],
	"./arrow-bar-up.svg": [
		34137,
		34137
	],
	"./arrow-clockwise.svg": [
		67234,
		67234
	],
	"./arrow-counterclockwise.svg": [
		55486,
		55486
	],
	"./arrow-down-circle-fill.svg": [
		55056,
		55056
	],
	"./arrow-down-circle.svg": [
		41238,
		41238
	],
	"./arrow-down-left-circle-fill.svg": [
		17560,
		17560
	],
	"./arrow-down-left-circle.svg": [
		20006,
		20006
	],
	"./arrow-down-left-square-fill.svg": [
		82847,
		82847
	],
	"./arrow-down-left-square.svg": [
		53310,
		53310
	],
	"./arrow-down-left.svg": [
		92627,
		92627
	],
	"./arrow-down-right-circle-fill.svg": [
		69558,
		69558
	],
	"./arrow-down-right-circle.svg": [
		43369,
		43369
	],
	"./arrow-down-right-square-fill.svg": [
		81752,
		81752
	],
	"./arrow-down-right-square.svg": [
		95957,
		95957
	],
	"./arrow-down-right.svg": [
		78593,
		78593
	],
	"./arrow-down-short.svg": [
		85982,
		85982
	],
	"./arrow-down-square-fill.svg": [
		37546,
		37546
	],
	"./arrow-down-square.svg": [
		14781,
		14781
	],
	"./arrow-down-up.svg": [
		15953,
		15953
	],
	"./arrow-down.svg": [
		32985,
		32985
	],
	"./arrow-left-circle-fill.svg": [
		9893,
		9893
	],
	"./arrow-left-circle.svg": [
		25605,
		25605
	],
	"./arrow-left-right.svg": [
		46864,
		46864
	],
	"./arrow-left-short.svg": [
		69719,
		69719
	],
	"./arrow-left-square-fill.svg": [
		22193,
		22193
	],
	"./arrow-left-square.svg": [
		1125,
		1125
	],
	"./arrow-left.svg": [
		79238,
		79238
	],
	"./arrow-repeat.svg": [
		4240,
		4240
	],
	"./arrow-return-left.svg": [
		14651,
		14651
	],
	"./arrow-return-right.svg": [
		60248,
		60248
	],
	"./arrow-right-circle-fill.svg": [
		8545,
		8545
	],
	"./arrow-right-circle.svg": [
		66618,
		66618
	],
	"./arrow-right-short.svg": [
		23731,
		23731
	],
	"./arrow-right-square-fill.svg": [
		40045,
		40045
	],
	"./arrow-right-square.svg": [
		38574,
		38574
	],
	"./arrow-right.svg": [
		22897,
		22897
	],
	"./arrow-through-heart-fill.svg": [
		28099,
		28099
	],
	"./arrow-through-heart.svg": [
		36537,
		36537
	],
	"./arrow-up-circle-fill.svg": [
		66477,
		66477
	],
	"./arrow-up-circle.svg": [
		27397,
		27397
	],
	"./arrow-up-left-circle-fill.svg": [
		92151,
		92151
	],
	"./arrow-up-left-circle.svg": [
		62924,
		62924
	],
	"./arrow-up-left-square-fill.svg": [
		87054,
		87054
	],
	"./arrow-up-left-square.svg": [
		57734,
		57734
	],
	"./arrow-up-left.svg": [
		86513,
		86513
	],
	"./arrow-up-right-circle-fill.svg": [
		70143,
		70143
	],
	"./arrow-up-right-circle.svg": [
		15619,
		15619
	],
	"./arrow-up-right-square-fill.svg": [
		94257,
		94257
	],
	"./arrow-up-right-square.svg": [
		10714,
		10714
	],
	"./arrow-up-right.svg": [
		67240,
		67240
	],
	"./arrow-up-short.svg": [
		58666,
		58666
	],
	"./arrow-up-square-fill.svg": [
		2573,
		2573
	],
	"./arrow-up-square.svg": [
		36833,
		36833
	],
	"./arrow-up.svg": [
		74522,
		74522
	],
	"./arrows-angle-contract.svg": [
		31427,
		31427
	],
	"./arrows-angle-expand.svg": [
		20944,
		20944
	],
	"./arrows-collapse-vertical.svg": [
		87154,
		87154
	],
	"./arrows-collapse.svg": [
		15406,
		15406
	],
	"./arrows-expand-vertical.svg": [
		91056,
		91056
	],
	"./arrows-expand.svg": [
		8893,
		8893
	],
	"./arrows-fullscreen.svg": [
		71732,
		71732
	],
	"./arrows-move.svg": [
		29864,
		29864
	],
	"./arrows-vertical.svg": [
		26246,
		26246
	],
	"./arrows.svg": [
		16639,
		16639
	],
	"./aspect-ratio-fill.svg": [
		75989,
		75989
	],
	"./aspect-ratio.svg": [
		11251,
		11251
	],
	"./asterisk.svg": [
		84991,
		84991
	],
	"./at.svg": [
		77140,
		77140
	],
	"./award-fill.svg": [
		65713,
		65713
	],
	"./award.svg": [
		74640,
		74640
	],
	"./back.svg": [
		96806,
		96806
	],
	"./backpack-fill.svg": [
		69814,
		69814
	],
	"./backpack.svg": [
		30842,
		30842
	],
	"./backpack2-fill.svg": [
		88041,
		88041
	],
	"./backpack2.svg": [
		78982,
		78982
	],
	"./backpack3-fill.svg": [
		91201,
		91201
	],
	"./backpack3.svg": [
		98313,
		98313
	],
	"./backpack4-fill.svg": [
		54794,
		54794
	],
	"./backpack4.svg": [
		70476,
		70476
	],
	"./backspace-fill.svg": [
		63493,
		63493
	],
	"./backspace-reverse-fill.svg": [
		23943,
		23943
	],
	"./backspace-reverse.svg": [
		29564,
		29564
	],
	"./backspace.svg": [
		99171,
		99171
	],
	"./badge-3d-fill.svg": [
		8630,
		8630
	],
	"./badge-3d.svg": [
		70504,
		70504
	],
	"./badge-4k-fill.svg": [
		9643,
		9643
	],
	"./badge-4k.svg": [
		13211,
		13211
	],
	"./badge-8k-fill.svg": [
		35016,
		35016
	],
	"./badge-8k.svg": [
		13448,
		13448
	],
	"./badge-ad-fill.svg": [
		32988,
		32988
	],
	"./badge-ad.svg": [
		55875,
		55875
	],
	"./badge-ar-fill.svg": [
		59891,
		59891
	],
	"./badge-ar.svg": [
		64799,
		64799
	],
	"./badge-cc-fill.svg": [
		12916,
		12916
	],
	"./badge-cc.svg": [
		48909,
		48909
	],
	"./badge-hd-fill.svg": [
		10602,
		10602
	],
	"./badge-hd.svg": [
		7120,
		7120
	],
	"./badge-sd-fill.svg": [
		73664,
		73664
	],
	"./badge-sd.svg": [
		65058,
		65058
	],
	"./badge-tm-fill.svg": [
		33893,
		33893
	],
	"./badge-tm.svg": [
		77952,
		77952
	],
	"./badge-vo-fill.svg": [
		5567,
		5567
	],
	"./badge-vo.svg": [
		19339,
		19339
	],
	"./badge-vr-fill.svg": [
		17558,
		17558
	],
	"./badge-vr.svg": [
		758,
		758
	],
	"./badge-wc-fill.svg": [
		92518,
		92518
	],
	"./badge-wc.svg": [
		44954,
		44954
	],
	"./bag-check-fill.svg": [
		64865,
		64865
	],
	"./bag-check.svg": [
		43532,
		43532
	],
	"./bag-dash-fill.svg": [
		43329,
		43329
	],
	"./bag-dash.svg": [
		84818,
		84818
	],
	"./bag-fill.svg": [
		47467,
		47467
	],
	"./bag-heart-fill.svg": [
		28982,
		28982
	],
	"./bag-heart.svg": [
		51121,
		51121
	],
	"./bag-plus-fill.svg": [
		14804,
		14804
	],
	"./bag-plus.svg": [
		77708,
		77708
	],
	"./bag-x-fill.svg": [
		94654,
		94654
	],
	"./bag-x.svg": [
		11351,
		11351
	],
	"./bag.svg": [
		68510,
		68510
	],
	"./balloon-fill.svg": [
		67786,
		67786
	],
	"./balloon-heart-fill.svg": [
		58873,
		58873
	],
	"./balloon-heart.svg": [
		25776,
		25776
	],
	"./balloon.svg": [
		58386,
		58386
	],
	"./ban-fill.svg": [
		76005,
		76005
	],
	"./ban.svg": [
		75544,
		75544
	],
	"./bandaid-fill.svg": [
		37947,
		37947
	],
	"./bandaid.svg": [
		88124,
		88124
	],
	"./bank.svg": [
		62209,
		62209
	],
	"./bank2.svg": [
		59932,
		59932
	],
	"./bar-chart-fill.svg": [
		40400,
		40400
	],
	"./bar-chart-line-fill.svg": [
		82468,
		82468
	],
	"./bar-chart-line.svg": [
		95377,
		95377
	],
	"./bar-chart-steps.svg": [
		51253,
		51253
	],
	"./bar-chart.svg": [
		55403,
		55403
	],
	"./basket-fill.svg": [
		33599,
		33599
	],
	"./basket.svg": [
		41960,
		41960
	],
	"./basket2-fill.svg": [
		89250,
		89250
	],
	"./basket2.svg": [
		32929,
		32929
	],
	"./basket3-fill.svg": [
		39175,
		39175
	],
	"./basket3.svg": [
		67246,
		67246
	],
	"./battery-charging.svg": [
		75171,
		75171
	],
	"./battery-full.svg": [
		6101,
		6101
	],
	"./battery-half.svg": [
		8915,
		8915
	],
	"./battery.svg": [
		97751,
		97751
	],
	"./behance.svg": [
		25709,
		25709
	],
	"./bell-fill.svg": [
		54893,
		54893
	],
	"./bell-slash-fill.svg": [
		13994,
		13994
	],
	"./bell-slash.svg": [
		46861,
		46861
	],
	"./bell.svg": [
		80344,
		80344
	],
	"./bezier.svg": [
		90929,
		90929
	],
	"./bezier2.svg": [
		87374,
		87374
	],
	"./bicycle.svg": [
		24499,
		24499
	],
	"./bing.svg": [
		30485,
		30485
	],
	"./binoculars-fill.svg": [
		97202,
		97202
	],
	"./binoculars.svg": [
		24994,
		24994
	],
	"./blockquote-left.svg": [
		3160,
		3160
	],
	"./blockquote-right.svg": [
		39347,
		39347
	],
	"./bluetooth.svg": [
		43467,
		43467
	],
	"./body-text.svg": [
		5636,
		5636
	],
	"./book-fill.svg": [
		60911,
		60911
	],
	"./book-half.svg": [
		42335,
		42335
	],
	"./book.svg": [
		92236,
		92236
	],
	"./bookmark-check-fill.svg": [
		50939,
		50939
	],
	"./bookmark-check.svg": [
		26088,
		26088
	],
	"./bookmark-dash-fill.svg": [
		43595,
		43595
	],
	"./bookmark-dash.svg": [
		38430,
		38430
	],
	"./bookmark-fill.svg": [
		14898,
		14898
	],
	"./bookmark-heart-fill.svg": [
		94206,
		94206
	],
	"./bookmark-heart.svg": [
		60871,
		60871
	],
	"./bookmark-plus-fill.svg": [
		39897,
		39897
	],
	"./bookmark-plus.svg": [
		43892,
		43892
	],
	"./bookmark-star-fill.svg": [
		94379,
		94379
	],
	"./bookmark-star.svg": [
		71208,
		71208
	],
	"./bookmark-x-fill.svg": [
		74083,
		74083
	],
	"./bookmark-x.svg": [
		20587,
		20587
	],
	"./bookmark.svg": [
		69503,
		69503
	],
	"./bookmarks-fill.svg": [
		51081,
		51081
	],
	"./bookmarks.svg": [
		31115,
		31115
	],
	"./bookshelf.svg": [
		12516,
		12516
	],
	"./boombox-fill.svg": [
		65218,
		65218
	],
	"./boombox.svg": [
		39036,
		39036
	],
	"./bootstrap-fill.svg": [
		29215,
		29215
	],
	"./bootstrap-reboot.svg": [
		23977,
		23977
	],
	"./bootstrap.svg": [
		73683,
		73683
	],
	"./border-all.svg": [
		8553,
		8553
	],
	"./border-bottom.svg": [
		40066,
		40066
	],
	"./border-center.svg": [
		81735,
		81735
	],
	"./border-inner.svg": [
		35459,
		35459
	],
	"./border-left.svg": [
		62107,
		62107
	],
	"./border-middle.svg": [
		81610,
		81610
	],
	"./border-outer.svg": [
		24355,
		24355
	],
	"./border-right.svg": [
		55227,
		55227
	],
	"./border-style.svg": [
		31598,
		31598
	],
	"./border-top.svg": [
		20662,
		20662
	],
	"./border-width.svg": [
		40841,
		40841
	],
	"./border.svg": [
		9166,
		9166
	],
	"./bounding-box-circles.svg": [
		99670,
		99670
	],
	"./bounding-box.svg": [
		34282,
		34282
	],
	"./box-arrow-down-left.svg": [
		98459,
		45978
	],
	"./box-arrow-down-right.svg": [
		62628,
		62628
	],
	"./box-arrow-down.svg": [
		92594,
		92594
	],
	"./box-arrow-in-down-left.svg": [
		76618,
		76618
	],
	"./box-arrow-in-down-right.svg": [
		363,
		363
	],
	"./box-arrow-in-down.svg": [
		26313,
		26313
	],
	"./box-arrow-in-left.svg": [
		32550,
		32550
	],
	"./box-arrow-in-right.svg": [
		4197,
		4197
	],
	"./box-arrow-in-up-left.svg": [
		90977,
		90977
	],
	"./box-arrow-in-up-right.svg": [
		1246,
		1246
	],
	"./box-arrow-in-up.svg": [
		19483,
		19483
	],
	"./box-arrow-left.svg": [
		6061,
		6061
	],
	"./box-arrow-right.svg": [
		77342,
		77342
	],
	"./box-arrow-up-left.svg": [
		11666,
		11666
	],
	"./box-arrow-up-right.svg": [
		34672,
		34672
	],
	"./box-arrow-up.svg": [
		69562,
		69562
	],
	"./box-fill.svg": [
		13962,
		13962
	],
	"./box-seam-fill.svg": [
		37436,
		37436
	],
	"./box-seam.svg": [
		34177,
		34177
	],
	"./box.svg": [
		30081,
		30081
	],
	"./box2-fill.svg": [
		6407,
		6407
	],
	"./box2-heart-fill.svg": [
		60017,
		60017
	],
	"./box2-heart.svg": [
		65217,
		65217
	],
	"./box2.svg": [
		33034,
		33034
	],
	"./boxes.svg": [
		24494,
		24494
	],
	"./braces-asterisk.svg": [
		28357,
		28357
	],
	"./braces.svg": [
		28941,
		28941
	],
	"./bricks.svg": [
		98636,
		98636
	],
	"./briefcase-fill.svg": [
		30724,
		30724
	],
	"./briefcase.svg": [
		67967,
		67967
	],
	"./brightness-alt-high-fill.svg": [
		47895,
		47895
	],
	"./brightness-alt-high.svg": [
		43229,
		43229
	],
	"./brightness-alt-low-fill.svg": [
		72373,
		72373
	],
	"./brightness-alt-low.svg": [
		3182,
		3182
	],
	"./brightness-high-fill.svg": [
		5520,
		5520
	],
	"./brightness-high.svg": [
		23838,
		23838
	],
	"./brightness-low-fill.svg": [
		46455,
		46455
	],
	"./brightness-low.svg": [
		74936,
		74936
	],
	"./brilliance.svg": [
		90499,
		90499
	],
	"./broadcast-pin.svg": [
		57498,
		57498
	],
	"./broadcast.svg": [
		39463,
		39463
	],
	"./browser-chrome.svg": [
		11302,
		11302
	],
	"./browser-edge.svg": [
		3372,
		3372
	],
	"./browser-firefox.svg": [
		74459,
		74459
	],
	"./browser-safari.svg": [
		25518,
		25518
	],
	"./brush-fill.svg": [
		553,
		553
	],
	"./brush.svg": [
		27902,
		27902
	],
	"./bucket-fill.svg": [
		60544,
		60544
	],
	"./bucket.svg": [
		83198,
		83198
	],
	"./bug-fill.svg": [
		30903,
		30903
	],
	"./bug.svg": [
		52436,
		52436
	],
	"./building-add.svg": [
		80792,
		80792
	],
	"./building-check.svg": [
		11106,
		11106
	],
	"./building-dash.svg": [
		76767,
		76767
	],
	"./building-down.svg": [
		22767,
		22767
	],
	"./building-exclamation.svg": [
		20434,
		20434
	],
	"./building-fill-add.svg": [
		4953,
		4953
	],
	"./building-fill-check.svg": [
		85886,
		85886
	],
	"./building-fill-dash.svg": [
		58320,
		58320
	],
	"./building-fill-down.svg": [
		3153,
		3153
	],
	"./building-fill-exclamation.svg": [
		22948,
		22948
	],
	"./building-fill-gear.svg": [
		99121,
		99121
	],
	"./building-fill-lock.svg": [
		37256,
		37256
	],
	"./building-fill-slash.svg": [
		81851,
		81851
	],
	"./building-fill-up.svg": [
		42503,
		42503
	],
	"./building-fill-x.svg": [
		55460,
		55460
	],
	"./building-fill.svg": [
		21900,
		21900
	],
	"./building-gear.svg": [
		61754,
		61754
	],
	"./building-lock.svg": [
		30221,
		30221
	],
	"./building-slash.svg": [
		88713,
		88713
	],
	"./building-up.svg": [
		9119,
		9119
	],
	"./building-x.svg": [
		10357,
		10357
	],
	"./building.svg": [
		26831,
		26831
	],
	"./buildings-fill.svg": [
		97311,
		97311
	],
	"./buildings.svg": [
		54739,
		54739
	],
	"./bullseye.svg": [
		80430,
		80430
	],
	"./bus-front-fill.svg": [
		37846,
		37846
	],
	"./bus-front.svg": [
		6222,
		6222
	],
	"./c-circle-fill.svg": [
		48856,
		48856
	],
	"./c-circle.svg": [
		637,
		637
	],
	"./c-square-fill.svg": [
		60498,
		60498
	],
	"./c-square.svg": [
		92827,
		92827
	],
	"./cake-fill.svg": [
		43166,
		43166
	],
	"./cake.svg": [
		58467,
		58467
	],
	"./cake2-fill.svg": [
		36561,
		36561
	],
	"./cake2.svg": [
		85948,
		85948
	],
	"./calculator-fill.svg": [
		19257,
		19257
	],
	"./calculator.svg": [
		54752,
		54752
	],
	"./calendar-check-fill.svg": [
		28399,
		28399
	],
	"./calendar-check.svg": [
		69186,
		69186
	],
	"./calendar-date-fill.svg": [
		99535,
		99535
	],
	"./calendar-date.svg": [
		35698,
		35698
	],
	"./calendar-day-fill.svg": [
		62342,
		62342
	],
	"./calendar-day.svg": [
		44392,
		44392
	],
	"./calendar-event-fill.svg": [
		61811,
		61811
	],
	"./calendar-event.svg": [
		42877,
		42877
	],
	"./calendar-fill.svg": [
		80598,
		80598
	],
	"./calendar-heart-fill.svg": [
		77870,
		77870
	],
	"./calendar-heart.svg": [
		72668,
		72668
	],
	"./calendar-minus-fill.svg": [
		5038,
		5038
	],
	"./calendar-minus.svg": [
		26143,
		26143
	],
	"./calendar-month-fill.svg": [
		70468,
		70468
	],
	"./calendar-month.svg": [
		95505,
		95505
	],
	"./calendar-plus-fill.svg": [
		8959,
		8959
	],
	"./calendar-plus.svg": [
		28436,
		52947
	],
	"./calendar-range-fill.svg": [
		80182,
		80182
	],
	"./calendar-range.svg": [
		7037,
		7037
	],
	"./calendar-week-fill.svg": [
		45313,
		45313
	],
	"./calendar-week.svg": [
		12610,
		12610
	],
	"./calendar-x-fill.svg": [
		92163,
		92163
	],
	"./calendar-x.svg": [
		13308,
		13308
	],
	"./calendar.svg": [
		71358,
		71358
	],
	"./calendar2-check-fill.svg": [
		27754,
		27754
	],
	"./calendar2-check.svg": [
		19084,
		19084
	],
	"./calendar2-date-fill.svg": [
		49270,
		49270
	],
	"./calendar2-date.svg": [
		67565,
		67565
	],
	"./calendar2-day-fill.svg": [
		38049,
		63259
	],
	"./calendar2-day.svg": [
		66325,
		66325
	],
	"./calendar2-event-fill.svg": [
		86773,
		86773
	],
	"./calendar2-event.svg": [
		51466,
		51466
	],
	"./calendar2-fill.svg": [
		82821,
		82821
	],
	"./calendar2-heart-fill.svg": [
		21683,
		21683
	],
	"./calendar2-heart.svg": [
		72224,
		72224
	],
	"./calendar2-minus-fill.svg": [
		59108,
		59108
	],
	"./calendar2-minus.svg": [
		86944,
		86944
	],
	"./calendar2-month-fill.svg": [
		96045,
		96045
	],
	"./calendar2-month.svg": [
		14635,
		14635
	],
	"./calendar2-plus-fill.svg": [
		43774,
		43774
	],
	"./calendar2-plus.svg": [
		92982,
		92982
	],
	"./calendar2-range-fill.svg": [
		83154,
		83154
	],
	"./calendar2-range.svg": [
		36590,
		36590
	],
	"./calendar2-week-fill.svg": [
		69853,
		69853
	],
	"./calendar2-week.svg": [
		76611,
		76611
	],
	"./calendar2-x-fill.svg": [
		26128,
		26128
	],
	"./calendar2-x.svg": [
		72306,
		72306
	],
	"./calendar2.svg": [
		39990,
		39990
	],
	"./calendar3-event-fill.svg": [
		72823,
		72823
	],
	"./calendar3-event.svg": [
		93528,
		93528
	],
	"./calendar3-fill.svg": [
		27915,
		27915
	],
	"./calendar3-range-fill.svg": [
		85357,
		85357
	],
	"./calendar3-range.svg": [
		95410,
		95410
	],
	"./calendar3-week-fill.svg": [
		83599,
		83599
	],
	"./calendar3-week.svg": [
		16791,
		16791
	],
	"./calendar3.svg": [
		90239,
		90239
	],
	"./calendar4-event.svg": [
		26003,
		26003
	],
	"./calendar4-range.svg": [
		96582,
		96582
	],
	"./calendar4-week.svg": [
		89848,
		89848
	],
	"./calendar4.svg": [
		90563,
		90563
	],
	"./camera-fill.svg": [
		15945,
		15945
	],
	"./camera-reels-fill.svg": [
		72549,
		72549
	],
	"./camera-reels.svg": [
		56482,
		93030
	],
	"./camera-video-fill.svg": [
		95873,
		95873
	],
	"./camera-video-off-fill.svg": [
		48584,
		48584
	],
	"./camera-video-off.svg": [
		59838,
		59838
	],
	"./camera-video.svg": [
		66902,
		66902
	],
	"./camera.svg": [
		27064,
		27064
	],
	"./camera2.svg": [
		29309,
		29309
	],
	"./capslock-fill.svg": [
		936,
		936
	],
	"./capslock.svg": [
		26492,
		26492
	],
	"./capsule-pill.svg": [
		29529,
		29529
	],
	"./capsule.svg": [
		65542,
		65542
	],
	"./car-front-fill.svg": [
		66002,
		66002
	],
	"./car-front.svg": [
		87809,
		87809
	],
	"./card-checklist.svg": [
		4590,
		4590
	],
	"./card-heading.svg": [
		98073,
		98073
	],
	"./card-image.svg": [
		11638,
		11638
	],
	"./card-list.svg": [
		80037,
		80037
	],
	"./card-text.svg": [
		60937,
		60937
	],
	"./caret-down-fill.svg": [
		20092,
		20092
	],
	"./caret-down-square-fill.svg": [
		75133,
		75133
	],
	"./caret-down-square.svg": [
		91537,
		91537
	],
	"./caret-down.svg": [
		31847,
		31847
	],
	"./caret-left-fill.svg": [
		92199,
		92199
	],
	"./caret-left-square-fill.svg": [
		3748,
		3748
	],
	"./caret-left-square.svg": [
		67487,
		67487
	],
	"./caret-left.svg": [
		15936,
		15936
	],
	"./caret-right-fill.svg": [
		23406,
		23406
	],
	"./caret-right-square-fill.svg": [
		97342,
		97342
	],
	"./caret-right-square.svg": [
		72540,
		72540
	],
	"./caret-right.svg": [
		95307,
		95307
	],
	"./caret-up-fill.svg": [
		51421,
		51421
	],
	"./caret-up-square-fill.svg": [
		90294,
		90294
	],
	"./caret-up-square.svg": [
		96831,
		96831
	],
	"./caret-up.svg": [
		55761,
		55761
	],
	"./cart-check-fill.svg": [
		86078,
		86078
	],
	"./cart-check.svg": [
		54091,
		54091
	],
	"./cart-dash-fill.svg": [
		91926,
		91926
	],
	"./cart-dash.svg": [
		96101,
		96101
	],
	"./cart-fill.svg": [
		47932,
		47932
	],
	"./cart-plus-fill.svg": [
		52289,
		52289
	],
	"./cart-plus.svg": [
		94959,
		94959
	],
	"./cart-x-fill.svg": [
		78553,
		78553
	],
	"./cart-x.svg": [
		18075,
		18075
	],
	"./cart.svg": [
		6055,
		6055
	],
	"./cart2.svg": [
		25845,
		25845
	],
	"./cart3.svg": [
		93939,
		93939
	],
	"./cart4.svg": [
		10069,
		10069
	],
	"./cash-coin.svg": [
		55640,
		55640
	],
	"./cash-stack.svg": [
		29069,
		29069
	],
	"./cash.svg": [
		30596,
		30596
	],
	"./cassette-fill.svg": [
		14447,
		14447
	],
	"./cassette.svg": [
		75659,
		75659
	],
	"./cast.svg": [
		97022,
		97022
	],
	"./cc-circle-fill.svg": [
		43233,
		43233
	],
	"./cc-circle.svg": [
		93159,
		93159
	],
	"./cc-square-fill.svg": [
		4534,
		28436
	],
	"./cc-square.svg": [
		9490,
		9490
	],
	"./chat-dots-fill.svg": [
		57123,
		57123
	],
	"./chat-dots.svg": [
		190,
		190
	],
	"./chat-fill.svg": [
		72948,
		72948
	],
	"./chat-heart-fill.svg": [
		77374,
		77374
	],
	"./chat-heart.svg": [
		14608,
		14608
	],
	"./chat-left-dots-fill.svg": [
		71862,
		64977
	],
	"./chat-left-dots.svg": [
		31842,
		56482
	],
	"./chat-left-fill.svg": [
		24497,
		24497
	],
	"./chat-left-heart-fill.svg": [
		47973,
		47973
	],
	"./chat-left-heart.svg": [
		10541,
		10541
	],
	"./chat-left-quote-fill.svg": [
		36915,
		36915
	],
	"./chat-left-quote.svg": [
		16184,
		16184
	],
	"./chat-left-text-fill.svg": [
		36360,
		36360
	],
	"./chat-left-text.svg": [
		78354,
		78354
	],
	"./chat-left.svg": [
		38119,
		38119
	],
	"./chat-quote-fill.svg": [
		70564,
		70564
	],
	"./chat-quote.svg": [
		30366,
		30366
	],
	"./chat-right-dots-fill.svg": [
		29236,
		29236
	],
	"./chat-right-dots.svg": [
		75402,
		75402
	],
	"./chat-right-fill.svg": [
		99933,
		99933
	],
	"./chat-right-heart-fill.svg": [
		2427,
		2427
	],
	"./chat-right-heart.svg": [
		20659,
		20659
	],
	"./chat-right-quote-fill.svg": [
		73635,
		73635
	],
	"./chat-right-quote.svg": [
		96637,
		96637
	],
	"./chat-right-text-fill.svg": [
		88191,
		88191
	],
	"./chat-right-text.svg": [
		77331,
		77331
	],
	"./chat-right.svg": [
		62842,
		62842
	],
	"./chat-square-dots-fill.svg": [
		83297,
		83297
	],
	"./chat-square-dots.svg": [
		5993,
		5993
	],
	"./chat-square-fill.svg": [
		94626,
		94626
	],
	"./chat-square-heart-fill.svg": [
		31074,
		31074
	],
	"./chat-square-heart.svg": [
		95335,
		95335
	],
	"./chat-square-quote-fill.svg": [
		49717,
		49717
	],
	"./chat-square-quote.svg": [
		87519,
		87519
	],
	"./chat-square-text-fill.svg": [
		4195,
		4195
	],
	"./chat-square-text.svg": [
		14573,
		14573
	],
	"./chat-square.svg": [
		6105,
		6105
	],
	"./chat-text-fill.svg": [
		69291,
		69291
	],
	"./chat-text.svg": [
		73422,
		73422
	],
	"./chat.svg": [
		31906,
		31906
	],
	"./check-all.svg": [
		86004,
		86004
	],
	"./check-circle-fill.svg": [
		98521,
		98521
	],
	"./check-circle.svg": [
		57752,
		57752
	],
	"./check-lg.svg": [
		43810,
		43810
	],
	"./check-square-fill.svg": [
		60069,
		60069
	],
	"./check-square.svg": [
		37789,
		37789
	],
	"./check.svg": [
		60394,
		60394
	],
	"./check2-all.svg": [
		99375,
		99375
	],
	"./check2-circle.svg": [
		50497,
		50497
	],
	"./check2-square.svg": [
		86863,
		86863
	],
	"./check2.svg": [
		53966,
		53966
	],
	"./chevron-bar-contract.svg": [
		81483,
		81483
	],
	"./chevron-bar-down.svg": [
		68064,
		68064
	],
	"./chevron-bar-expand.svg": [
		38740,
		38740
	],
	"./chevron-bar-left.svg": [
		91178,
		91178
	],
	"./chevron-bar-right.svg": [
		13745,
		13745
	],
	"./chevron-bar-up.svg": [
		21904,
		21904
	],
	"./chevron-compact-down.svg": [
		98733,
		98733
	],
	"./chevron-compact-left.svg": [
		75129,
		75129
	],
	"./chevron-compact-right.svg": [
		87797,
		87797
	],
	"./chevron-compact-up.svg": [
		81808,
		81808
	],
	"./chevron-contract.svg": [
		7199,
		7199
	],
	"./chevron-double-down.svg": [
		47492,
		47492
	],
	"./chevron-double-left.svg": [
		86757,
		86757
	],
	"./chevron-double-right.svg": [
		77775,
		77775
	],
	"./chevron-double-up.svg": [
		77880,
		77880
	],
	"./chevron-down.svg": [
		65787,
		65787
	],
	"./chevron-expand.svg": [
		5816,
		5816
	],
	"./chevron-left.svg": [
		81547,
		81547
	],
	"./chevron-right.svg": [
		13871,
		13871
	],
	"./chevron-up.svg": [
		41614,
		41614
	],
	"./circle-fill.svg": [
		20298,
		20298
	],
	"./circle-half.svg": [
		59026,
		59026
	],
	"./circle-square.svg": [
		38585,
		38585
	],
	"./circle.svg": [
		95987,
		95987
	],
	"./clipboard-check-fill.svg": [
		67929,
		67929
	],
	"./clipboard-check.svg": [
		35236,
		35236
	],
	"./clipboard-data-fill.svg": [
		64290,
		64290
	],
	"./clipboard-data.svg": [
		30382,
		30382
	],
	"./clipboard-fill.svg": [
		83439,
		83439
	],
	"./clipboard-heart-fill.svg": [
		14268,
		14268
	],
	"./clipboard-heart.svg": [
		66307,
		66307
	],
	"./clipboard-minus-fill.svg": [
		32101,
		32101
	],
	"./clipboard-minus.svg": [
		98656,
		98656
	],
	"./clipboard-plus-fill.svg": [
		1173,
		1173
	],
	"./clipboard-plus.svg": [
		88486,
		88486
	],
	"./clipboard-pulse.svg": [
		25379,
		25379
	],
	"./clipboard-x-fill.svg": [
		21080,
		21080
	],
	"./clipboard-x.svg": [
		29339,
		29339
	],
	"./clipboard.svg": [
		59914,
		59914
	],
	"./clipboard2-check-fill.svg": [
		87080,
		87080
	],
	"./clipboard2-check.svg": [
		47633,
		47633
	],
	"./clipboard2-data-fill.svg": [
		62735,
		62735
	],
	"./clipboard2-data.svg": [
		75605,
		75605
	],
	"./clipboard2-fill.svg": [
		16374,
		16374
	],
	"./clipboard2-heart-fill.svg": [
		71991,
		71991
	],
	"./clipboard2-heart.svg": [
		8636,
		8636
	],
	"./clipboard2-minus-fill.svg": [
		86981,
		86981
	],
	"./clipboard2-minus.svg": [
		92509,
		23172
	],
	"./clipboard2-plus-fill.svg": [
		33675,
		33675
	],
	"./clipboard2-plus.svg": [
		86521,
		86521
	],
	"./clipboard2-pulse-fill.svg": [
		65738,
		65738
	],
	"./clipboard2-pulse.svg": [
		9640,
		9640
	],
	"./clipboard2-x-fill.svg": [
		59625,
		57435
	],
	"./clipboard2-x.svg": [
		57422,
		57422
	],
	"./clipboard2.svg": [
		91525,
		91525
	],
	"./clock-fill.svg": [
		58859,
		58859
	],
	"./clock-history.svg": [
		85257,
		85257
	],
	"./clock.svg": [
		13243,
		13243
	],
	"./cloud-arrow-down-fill.svg": [
		80702,
		80702
	],
	"./cloud-arrow-down.svg": [
		17081,
		17081
	],
	"./cloud-arrow-up-fill.svg": [
		63673,
		63673
	],
	"./cloud-arrow-up.svg": [
		18015,
		18015
	],
	"./cloud-check-fill.svg": [
		58809,
		58809
	],
	"./cloud-check.svg": [
		54115,
		54115
	],
	"./cloud-download-fill.svg": [
		94903,
		94903
	],
	"./cloud-download.svg": [
		7118,
		7118
	],
	"./cloud-drizzle-fill.svg": [
		51174,
		51174
	],
	"./cloud-drizzle.svg": [
		69998,
		69998
	],
	"./cloud-fill.svg": [
		35773,
		35773
	],
	"./cloud-fog-fill.svg": [
		83227,
		83227
	],
	"./cloud-fog.svg": [
		74529,
		74529
	],
	"./cloud-fog2-fill.svg": [
		12853,
		12853
	],
	"./cloud-fog2.svg": [
		78922,
		78922
	],
	"./cloud-hail-fill.svg": [
		32813,
		32813
	],
	"./cloud-hail.svg": [
		15059,
		15059
	],
	"./cloud-haze-fill.svg": [
		60691,
		59798
	],
	"./cloud-haze.svg": [
		26382,
		26382
	],
	"./cloud-haze2-fill.svg": [
		75461,
		75461
	],
	"./cloud-haze2.svg": [
		25302,
		25302
	],
	"./cloud-lightning-fill.svg": [
		74971,
		74971
	],
	"./cloud-lightning-rain-fill.svg": [
		10235,
		10235
	],
	"./cloud-lightning-rain.svg": [
		15824,
		15824
	],
	"./cloud-lightning.svg": [
		20016,
		20016
	],
	"./cloud-minus-fill.svg": [
		43586,
		43586
	],
	"./cloud-minus.svg": [
		54260,
		54260
	],
	"./cloud-moon-fill.svg": [
		23033,
		23033
	],
	"./cloud-moon.svg": [
		15763,
		15763
	],
	"./cloud-plus-fill.svg": [
		96014,
		96014
	],
	"./cloud-plus.svg": [
		68461,
		68461
	],
	"./cloud-rain-fill.svg": [
		39666,
		39666
	],
	"./cloud-rain-heavy-fill.svg": [
		89166,
		89166
	],
	"./cloud-rain-heavy.svg": [
		49078,
		49078
	],
	"./cloud-rain.svg": [
		71028,
		71028
	],
	"./cloud-slash-fill.svg": [
		46634,
		46634
	],
	"./cloud-slash.svg": [
		64911,
		64911
	],
	"./cloud-sleet-fill.svg": [
		114,
		114
	],
	"./cloud-sleet.svg": [
		7785,
		7785
	],
	"./cloud-snow-fill.svg": [
		86149,
		86149
	],
	"./cloud-snow.svg": [
		54121,
		54121
	],
	"./cloud-sun-fill.svg": [
		87268,
		87268
	],
	"./cloud-sun.svg": [
		42221,
		42221
	],
	"./cloud-upload-fill.svg": [
		51367,
		51367
	],
	"./cloud-upload.svg": [
		74393,
		74393
	],
	"./cloud.svg": [
		66126,
		66126
	],
	"./clouds-fill.svg": [
		99972,
		99972
	],
	"./clouds.svg": [
		19087,
		19087
	],
	"./cloudy-fill.svg": [
		24465,
		24465
	],
	"./cloudy.svg": [
		5596,
		5596
	],
	"./code-slash.svg": [
		6746,
		6746
	],
	"./code-square.svg": [
		75439,
		75439
	],
	"./code.svg": [
		40678,
		40678
	],
	"./coin.svg": [
		86529,
		86529
	],
	"./collection-fill.svg": [
		95663,
		95663
	],
	"./collection-play-fill.svg": [
		45361,
		45361
	],
	"./collection-play.svg": [
		57017,
		57017
	],
	"./collection.svg": [
		73776,
		73776
	],
	"./columns-gap.svg": [
		70192,
		70192
	],
	"./columns.svg": [
		55950,
		55950
	],
	"./command.svg": [
		90020,
		90020
	],
	"./compass-fill.svg": [
		44489,
		44489
	],
	"./compass.svg": [
		87000,
		87000
	],
	"./cone-striped.svg": [
		19788,
		19788
	],
	"./cone.svg": [
		52201,
		52201
	],
	"./controller.svg": [
		5303,
		5303
	],
	"./cookie.svg": [
		90747,
		22444
	],
	"./copy.svg": [
		85653,
		85653
	],
	"./cpu-fill.svg": [
		43848,
		43848
	],
	"./cpu.svg": [
		8235,
		8235
	],
	"./credit-card-2-back-fill.svg": [
		59981,
		59981
	],
	"./credit-card-2-back.svg": [
		64279,
		64279
	],
	"./credit-card-2-front-fill.svg": [
		124,
		124
	],
	"./credit-card-2-front.svg": [
		69545,
		69545
	],
	"./credit-card-fill.svg": [
		32401,
		32401
	],
	"./credit-card.svg": [
		94853,
		94853
	],
	"./crop.svg": [
		71126,
		71126
	],
	"./crosshair.svg": [
		82492,
		82492
	],
	"./crosshair2.svg": [
		56449,
		56449
	],
	"./cup-fill.svg": [
		60733,
		60733
	],
	"./cup-hot-fill.svg": [
		51715,
		51715
	],
	"./cup-hot.svg": [
		12283,
		12283
	],
	"./cup-straw.svg": [
		10746,
		10746
	],
	"./cup.svg": [
		31019,
		31019
	],
	"./currency-bitcoin.svg": [
		46034,
		46034
	],
	"./currency-dollar.svg": [
		66720,
		66720
	],
	"./currency-euro.svg": [
		2037,
		2037
	],
	"./currency-exchange.svg": [
		38752,
		38752
	],
	"./currency-pound.svg": [
		43167,
		43167
	],
	"./currency-rupee.svg": [
		49218,
		49218
	],
	"./currency-yen.svg": [
		63385,
		63385
	],
	"./cursor-fill.svg": [
		75442,
		75442
	],
	"./cursor-text.svg": [
		23561,
		23561
	],
	"./cursor.svg": [
		45932,
		45932
	],
	"./dash-circle-dotted.svg": [
		93284,
		93284
	],
	"./dash-circle-fill.svg": [
		19160,
		19160
	],
	"./dash-circle.svg": [
		82883,
		82883
	],
	"./dash-lg.svg": [
		77415,
		77415
	],
	"./dash-square-dotted.svg": [
		68094,
		68094
	],
	"./dash-square-fill.svg": [
		14041,
		14041
	],
	"./dash-square.svg": [
		70337,
		70337
	],
	"./dash.svg": [
		65263,
		65263
	],
	"./database-add.svg": [
		7835,
		7835
	],
	"./database-check.svg": [
		15892,
		15892
	],
	"./database-dash.svg": [
		87130,
		87130
	],
	"./database-down.svg": [
		84754,
		84754
	],
	"./database-exclamation.svg": [
		49171,
		49171
	],
	"./database-fill-add.svg": [
		40014,
		40014
	],
	"./database-fill-check.svg": [
		68726,
		68726
	],
	"./database-fill-dash.svg": [
		72750,
		72750
	],
	"./database-fill-down.svg": [
		3393,
		3393
	],
	"./database-fill-exclamation.svg": [
		19509,
		19509
	],
	"./database-fill-gear.svg": [
		19125,
		19125
	],
	"./database-fill-lock.svg": [
		98082,
		98082
	],
	"./database-fill-slash.svg": [
		34962,
		34962
	],
	"./database-fill-up.svg": [
		76682,
		76682
	],
	"./database-fill-x.svg": [
		96436,
		96436
	],
	"./database-fill.svg": [
		29108,
		29108
	],
	"./database-gear.svg": [
		31296,
		31296
	],
	"./database-lock.svg": [
		7667,
		7667
	],
	"./database-slash.svg": [
		9546,
		9546
	],
	"./database-up.svg": [
		23638,
		23638
	],
	"./database-x.svg": [
		47127,
		47127
	],
	"./database.svg": [
		8050,
		8050
	],
	"./device-hdd-fill.svg": [
		19669,
		19669
	],
	"./device-hdd.svg": [
		2994,
		2994
	],
	"./device-ssd-fill.svg": [
		18037,
		18037
	],
	"./device-ssd.svg": [
		77270,
		77270
	],
	"./diagram-2-fill.svg": [
		61595,
		61595
	],
	"./diagram-2.svg": [
		62939,
		62939
	],
	"./diagram-3-fill.svg": [
		13044,
		13044
	],
	"./diagram-3.svg": [
		37772,
		37772
	],
	"./diamond-fill.svg": [
		81811,
		81811
	],
	"./diamond-half.svg": [
		46367,
		46367
	],
	"./diamond.svg": [
		68061,
		68061
	],
	"./dice-1-fill.svg": [
		73256,
		73256
	],
	"./dice-1.svg": [
		60548,
		60548
	],
	"./dice-2-fill.svg": [
		60779,
		60779
	],
	"./dice-2.svg": [
		59556,
		59556
	],
	"./dice-3-fill.svg": [
		1894,
		1894
	],
	"./dice-3.svg": [
		24049,
		24049
	],
	"./dice-4-fill.svg": [
		95271,
		95271
	],
	"./dice-4.svg": [
		34586,
		34586
	],
	"./dice-5-fill.svg": [
		35573,
		35573
	],
	"./dice-5.svg": [
		39265,
		60691
	],
	"./dice-6-fill.svg": [
		45432,
		45432
	],
	"./dice-6.svg": [
		12433,
		12433
	],
	"./disc-fill.svg": [
		6010,
		6010
	],
	"./disc.svg": [
		19075,
		19075
	],
	"./discord.svg": [
		43808,
		43808
	],
	"./display-fill.svg": [
		60465,
		60465
	],
	"./display.svg": [
		68212,
		68212
	],
	"./displayport-fill.svg": [
		11166,
		11166
	],
	"./displayport.svg": [
		18999,
		18999
	],
	"./distribute-horizontal.svg": [
		25447,
		25447
	],
	"./distribute-vertical.svg": [
		73923,
		73923
	],
	"./door-closed-fill.svg": [
		43006,
		43006
	],
	"./door-closed.svg": [
		30091,
		57887
	],
	"./door-open-fill.svg": [
		97314,
		97314
	],
	"./door-open.svg": [
		68246,
		68246
	],
	"./dot.svg": [
		95050,
		95050
	],
	"./download.svg": [
		36341,
		36341
	],
	"./dpad-fill.svg": [
		81677,
		81677
	],
	"./dpad.svg": [
		74723,
		74723
	],
	"./dribbble.svg": [
		7286,
		7286
	],
	"./dropbox.svg": [
		16059,
		16059
	],
	"./droplet-fill.svg": [
		18239,
		18239
	],
	"./droplet-half.svg": [
		14,
		14
	],
	"./droplet.svg": [
		88634,
		88634
	],
	"./duffle-fill.svg": [
		39333,
		39333
	],
	"./duffle.svg": [
		39375,
		39375
	],
	"./ear-fill.svg": [
		49625,
		49625
	],
	"./ear.svg": [
		76206,
		76206
	],
	"./earbuds.svg": [
		67924,
		67924
	],
	"./easel-fill.svg": [
		76688,
		76688
	],
	"./easel.svg": [
		17598,
		17598
	],
	"./easel2-fill.svg": [
		31703,
		31703
	],
	"./easel2.svg": [
		17695,
		17695
	],
	"./easel3-fill.svg": [
		17510,
		17510
	],
	"./easel3.svg": [
		76864,
		76864
	],
	"./egg-fill.svg": [
		3752,
		3752
	],
	"./egg-fried.svg": [
		80020,
		80020
	],
	"./egg.svg": [
		24200,
		24200
	],
	"./eject-fill.svg": [
		48255,
		48255
	],
	"./eject.svg": [
		9997,
		9997
	],
	"./emoji-angry-fill.svg": [
		76847,
		76847
	],
	"./emoji-angry.svg": [
		24887,
		24887
	],
	"./emoji-astonished-fill.svg": [
		18625,
		18625
	],
	"./emoji-astonished.svg": [
		68272,
		68272
	],
	"./emoji-dizzy-fill.svg": [
		86626,
		86626
	],
	"./emoji-dizzy.svg": [
		63339,
		63339
	],
	"./emoji-expressionless-fill.svg": [
		82289,
		82289
	],
	"./emoji-expressionless.svg": [
		6530,
		6530
	],
	"./emoji-frown-fill.svg": [
		21076,
		21076
	],
	"./emoji-frown.svg": [
		52651,
		52651
	],
	"./emoji-grimace-fill.svg": [
		71307,
		71307
	],
	"./emoji-grimace.svg": [
		83416,
		83416
	],
	"./emoji-grin-fill.svg": [
		36458,
		36458
	],
	"./emoji-grin.svg": [
		94924,
		94924
	],
	"./emoji-heart-eyes-fill.svg": [
		78859,
		78859
	],
	"./emoji-heart-eyes.svg": [
		68944,
		68944
	],
	"./emoji-kiss-fill.svg": [
		53604,
		53604
	],
	"./emoji-kiss.svg": [
		98098,
		98098
	],
	"./emoji-laughing-fill.svg": [
		94417,
		94417
	],
	"./emoji-laughing.svg": [
		81929,
		81929
	],
	"./emoji-neutral-fill.svg": [
		61594,
		61594
	],
	"./emoji-neutral.svg": [
		94120,
		94120
	],
	"./emoji-smile-fill.svg": [
		96932,
		96932
	],
	"./emoji-smile-upside-down-fill.svg": [
		96160,
		96160
	],
	"./emoji-smile-upside-down.svg": [
		38716,
		38716
	],
	"./emoji-smile.svg": [
		83410,
		83410
	],
	"./emoji-sunglasses-fill.svg": [
		18940,
		18940
	],
	"./emoji-sunglasses.svg": [
		93173,
		93173
	],
	"./emoji-surprise-fill.svg": [
		40211,
		40211
	],
	"./emoji-surprise.svg": [
		14312,
		14312
	],
	"./emoji-tear-fill.svg": [
		60193,
		60193
	],
	"./emoji-tear.svg": [
		88814,
		88814
	],
	"./emoji-wink-fill.svg": [
		47636,
		47636
	],
	"./emoji-wink.svg": [
		13853,
		13853
	],
	"./envelope-arrow-down-fill.svg": [
		7531,
		7531
	],
	"./envelope-arrow-down.svg": [
		64313,
		64313
	],
	"./envelope-arrow-up-fill.svg": [
		40384,
		40384
	],
	"./envelope-arrow-up.svg": [
		99348,
		99348
	],
	"./envelope-at-fill.svg": [
		36482,
		36482
	],
	"./envelope-at.svg": [
		89156,
		89156
	],
	"./envelope-check-fill.svg": [
		6715,
		6715
	],
	"./envelope-check.svg": [
		26413,
		26413
	],
	"./envelope-dash-fill.svg": [
		6411,
		6411
	],
	"./envelope-dash.svg": [
		83256,
		83256
	],
	"./envelope-exclamation-fill.svg": [
		55503,
		55503
	],
	"./envelope-exclamation.svg": [
		60385,
		60385
	],
	"./envelope-fill.svg": [
		34812,
		34812
	],
	"./envelope-heart-fill.svg": [
		80189,
		80189
	],
	"./envelope-heart.svg": [
		96059,
		96059
	],
	"./envelope-open-fill.svg": [
		94370,
		94370
	],
	"./envelope-open-heart-fill.svg": [
		46774,
		46774
	],
	"./envelope-open-heart.svg": [
		96210,
		96210
	],
	"./envelope-open.svg": [
		47780,
		47780
	],
	"./envelope-paper-fill.svg": [
		15497,
		15497
	],
	"./envelope-paper-heart-fill.svg": [
		15418,
		15418
	],
	"./envelope-paper-heart.svg": [
		53857,
		53857
	],
	"./envelope-paper.svg": [
		9104,
		9104
	],
	"./envelope-plus-fill.svg": [
		92698,
		92698
	],
	"./envelope-plus.svg": [
		11509,
		11509
	],
	"./envelope-slash-fill.svg": [
		6229,
		6229
	],
	"./envelope-slash.svg": [
		79283,
		79283
	],
	"./envelope-x-fill.svg": [
		30607,
		30607
	],
	"./envelope-x.svg": [
		75369,
		75369
	],
	"./envelope.svg": [
		36655,
		36655
	],
	"./eraser-fill.svg": [
		57199,
		57199
	],
	"./eraser.svg": [
		74716,
		74716
	],
	"./escape.svg": [
		92276,
		92276
	],
	"./ethernet.svg": [
		55599,
		55599
	],
	"./ev-front-fill.svg": [
		95770,
		10518
	],
	"./ev-front.svg": [
		89867,
		89867
	],
	"./ev-station-fill.svg": [
		47480,
		47480
	],
	"./ev-station.svg": [
		89678,
		89678
	],
	"./exclamation-circle-fill.svg": [
		73509,
		73509
	],
	"./exclamation-circle.svg": [
		32201,
		32201
	],
	"./exclamation-diamond-fill.svg": [
		46066,
		46066
	],
	"./exclamation-diamond.svg": [
		21573,
		21573
	],
	"./exclamation-lg.svg": [
		74409,
		74409
	],
	"./exclamation-octagon-fill.svg": [
		65607,
		65607
	],
	"./exclamation-octagon.svg": [
		15738,
		15738
	],
	"./exclamation-square-fill.svg": [
		35195,
		35195
	],
	"./exclamation-square.svg": [
		65082,
		65082
	],
	"./exclamation-triangle-fill.svg": [
		20545,
		20545
	],
	"./exclamation-triangle.svg": [
		78625,
		78625
	],
	"./exclamation.svg": [
		21062,
		21062
	],
	"./exclude.svg": [
		75546,
		75546
	],
	"./explicit-fill.svg": [
		43285,
		43285
	],
	"./explicit.svg": [
		12702,
		98459
	],
	"./exposure.svg": [
		63716,
		63716
	],
	"./eye-fill.svg": [
		88768,
		88768
	],
	"./eye-slash-fill.svg": [
		1529,
		1529
	],
	"./eye-slash.svg": [
		28494,
		28494
	],
	"./eye.svg": [
		20075,
		20075
	],
	"./eyedropper.svg": [
		9993,
		9993
	],
	"./eyeglasses.svg": [
		7093,
		7093
	],
	"./facebook.svg": [
		80202,
		80202
	],
	"./fan.svg": [
		33321,
		33321
	],
	"./fast-forward-btn-fill.svg": [
		68923,
		68923
	],
	"./fast-forward-btn.svg": [
		33413,
		33413
	],
	"./fast-forward-circle-fill.svg": [
		1001,
		1001
	],
	"./fast-forward-circle.svg": [
		33951,
		33951
	],
	"./fast-forward-fill.svg": [
		60619,
		60619
	],
	"./fast-forward.svg": [
		33806,
		33806
	],
	"./feather.svg": [
		67957,
		67957
	],
	"./feather2.svg": [
		11056,
		11056
	],
	"./file-arrow-down-fill.svg": [
		10807,
		10807
	],
	"./file-arrow-down.svg": [
		81130,
		81130
	],
	"./file-arrow-up-fill.svg": [
		8781,
		8781
	],
	"./file-arrow-up.svg": [
		95965,
		95965
	],
	"./file-bar-graph-fill.svg": [
		25910,
		25910
	],
	"./file-bar-graph.svg": [
		36519,
		36519
	],
	"./file-binary-fill.svg": [
		1939,
		1939
	],
	"./file-binary.svg": [
		25897,
		25897
	],
	"./file-break-fill.svg": [
		88598,
		88598
	],
	"./file-break.svg": [
		74623,
		74623
	],
	"./file-check-fill.svg": [
		12527,
		12527
	],
	"./file-check.svg": [
		96282,
		96282
	],
	"./file-code-fill.svg": [
		81461,
		81461
	],
	"./file-code.svg": [
		17471,
		17471
	],
	"./file-diff-fill.svg": [
		34836,
		34836
	],
	"./file-diff.svg": [
		46473,
		46473
	],
	"./file-earmark-arrow-down-fill.svg": [
		55041,
		55041
	],
	"./file-earmark-arrow-down.svg": [
		42892,
		42892
	],
	"./file-earmark-arrow-up-fill.svg": [
		61648,
		61648
	],
	"./file-earmark-arrow-up.svg": [
		73612,
		73612
	],
	"./file-earmark-bar-graph-fill.svg": [
		72168,
		72168
	],
	"./file-earmark-bar-graph.svg": [
		46695,
		46695
	],
	"./file-earmark-binary-fill.svg": [
		66946,
		66946
	],
	"./file-earmark-binary.svg": [
		43001,
		43001
	],
	"./file-earmark-break-fill.svg": [
		65455,
		65455
	],
	"./file-earmark-break.svg": [
		76897,
		76897
	],
	"./file-earmark-check-fill.svg": [
		7111,
		7111
	],
	"./file-earmark-check.svg": [
		74219,
		74219
	],
	"./file-earmark-code-fill.svg": [
		32403,
		32403
	],
	"./file-earmark-code.svg": [
		36289,
		36289
	],
	"./file-earmark-diff-fill.svg": [
		55368,
		55368
	],
	"./file-earmark-diff.svg": [
		52784,
		52784
	],
	"./file-earmark-easel-fill.svg": [
		22044,
		22044
	],
	"./file-earmark-easel.svg": [
		81682,
		81682
	],
	"./file-earmark-excel-fill.svg": [
		14720,
		14720
	],
	"./file-earmark-excel.svg": [
		77436,
		77436
	],
	"./file-earmark-fill.svg": [
		93480,
		93480
	],
	"./file-earmark-font-fill.svg": [
		61730,
		61730
	],
	"./file-earmark-font.svg": [
		52932,
		52932
	],
	"./file-earmark-image-fill.svg": [
		70707,
		70707
	],
	"./file-earmark-image.svg": [
		81566,
		81566
	],
	"./file-earmark-lock-fill.svg": [
		28342,
		28342
	],
	"./file-earmark-lock.svg": [
		76065,
		76065
	],
	"./file-earmark-lock2-fill.svg": [
		19811,
		19811
	],
	"./file-earmark-lock2.svg": [
		84439,
		84439
	],
	"./file-earmark-medical-fill.svg": [
		89162,
		90747
	],
	"./file-earmark-medical.svg": [
		83734,
		83734
	],
	"./file-earmark-minus-fill.svg": [
		25372,
		25372
	],
	"./file-earmark-minus.svg": [
		22800,
		22800
	],
	"./file-earmark-music-fill.svg": [
		11307,
		11307
	],
	"./file-earmark-music.svg": [
		43943,
		43943
	],
	"./file-earmark-pdf-fill.svg": [
		80932,
		80932
	],
	"./file-earmark-pdf.svg": [
		37089,
		37089
	],
	"./file-earmark-person-fill.svg": [
		45862,
		45862
	],
	"./file-earmark-person.svg": [
		63538,
		63538
	],
	"./file-earmark-play-fill.svg": [
		64053,
		64053
	],
	"./file-earmark-play.svg": [
		56550,
		56550
	],
	"./file-earmark-plus-fill.svg": [
		42691,
		42691
	],
	"./file-earmark-plus.svg": [
		25855,
		25855
	],
	"./file-earmark-post-fill.svg": [
		97754,
		97754
	],
	"./file-earmark-post.svg": [
		49510,
		49510
	],
	"./file-earmark-ppt-fill.svg": [
		47388,
		47388
	],
	"./file-earmark-ppt.svg": [
		70974,
		70974
	],
	"./file-earmark-richtext-fill.svg": [
		58978,
		58978
	],
	"./file-earmark-richtext.svg": [
		13936,
		13936
	],
	"./file-earmark-ruled-fill.svg": [
		75844,
		75844
	],
	"./file-earmark-ruled.svg": [
		93470,
		93470
	],
	"./file-earmark-slides-fill.svg": [
		57278,
		57278
	],
	"./file-earmark-slides.svg": [
		89556,
		9339
	],
	"./file-earmark-spreadsheet-fill.svg": [
		33430,
		58473
	],
	"./file-earmark-spreadsheet.svg": [
		68466,
		68466
	],
	"./file-earmark-text-fill.svg": [
		47533,
		47533
	],
	"./file-earmark-text.svg": [
		69830,
		69830
	],
	"./file-earmark-word-fill.svg": [
		88228,
		88228
	],
	"./file-earmark-word.svg": [
		13,
		13
	],
	"./file-earmark-x-fill.svg": [
		94270,
		94270
	],
	"./file-earmark-x.svg": [
		45081,
		45081
	],
	"./file-earmark-zip-fill.svg": [
		60731,
		60731
	],
	"./file-earmark-zip.svg": [
		75885,
		75885
	],
	"./file-earmark.svg": [
		92145,
		92145
	],
	"./file-easel-fill.svg": [
		79765,
		79765
	],
	"./file-easel.svg": [
		61390,
		61390
	],
	"./file-excel-fill.svg": [
		89493,
		89493
	],
	"./file-excel.svg": [
		21340,
		21340
	],
	"./file-fill.svg": [
		29201,
		29201
	],
	"./file-font-fill.svg": [
		93781,
		93781
	],
	"./file-font.svg": [
		2617,
		2617
	],
	"./file-image-fill.svg": [
		72640,
		72640
	],
	"./file-image.svg": [
		39936,
		39936
	],
	"./file-lock-fill.svg": [
		83525,
		83525
	],
	"./file-lock.svg": [
		71211,
		71211
	],
	"./file-lock2-fill.svg": [
		51423,
		51423
	],
	"./file-lock2.svg": [
		70758,
		70758
	],
	"./file-medical-fill.svg": [
		178,
		178
	],
	"./file-medical.svg": [
		90633,
		90633
	],
	"./file-minus-fill.svg": [
		94888,
		94888
	],
	"./file-minus.svg": [
		94407,
		94407
	],
	"./file-music-fill.svg": [
		65565,
		65565
	],
	"./file-music.svg": [
		60915,
		60915
	],
	"./file-pdf-fill.svg": [
		41814,
		41814
	],
	"./file-pdf.svg": [
		84159,
		84159
	],
	"./file-person-fill.svg": [
		6940,
		6940
	],
	"./file-person.svg": [
		48982,
		48982
	],
	"./file-play-fill.svg": [
		19456,
		19456
	],
	"./file-play.svg": [
		67498,
		67498
	],
	"./file-plus-fill.svg": [
		10121,
		10121
	],
	"./file-plus.svg": [
		12258,
		12258
	],
	"./file-post-fill.svg": [
		27697,
		27697
	],
	"./file-post.svg": [
		47906,
		47906
	],
	"./file-ppt-fill.svg": [
		57776,
		57776
	],
	"./file-ppt.svg": [
		64943,
		64943
	],
	"./file-richtext-fill.svg": [
		4259,
		4259
	],
	"./file-richtext.svg": [
		89485,
		89485
	],
	"./file-ruled-fill.svg": [
		11143,
		11143
	],
	"./file-ruled.svg": [
		15444,
		15444
	],
	"./file-slides-fill.svg": [
		43549,
		43549
	],
	"./file-slides.svg": [
		38837,
		38837
	],
	"./file-spreadsheet-fill.svg": [
		96309,
		96309
	],
	"./file-spreadsheet.svg": [
		46592,
		46592
	],
	"./file-text-fill.svg": [
		35929,
		35929
	],
	"./file-text.svg": [
		79626,
		79626
	],
	"./file-word-fill.svg": [
		36826,
		36826
	],
	"./file-word.svg": [
		49602,
		49602
	],
	"./file-x-fill.svg": [
		17613,
		17613
	],
	"./file-x.svg": [
		61921,
		61921
	],
	"./file-zip-fill.svg": [
		93965,
		93965
	],
	"./file-zip.svg": [
		59823,
		59823
	],
	"./file.svg": [
		13380,
		13380
	],
	"./files-alt.svg": [
		24876,
		24876
	],
	"./files.svg": [
		83719,
		83719
	],
	"./filetype-aac.svg": [
		21631,
		21631
	],
	"./filetype-ai.svg": [
		95618,
		95618
	],
	"./filetype-bmp.svg": [
		28141,
		28141
	],
	"./filetype-cs.svg": [
		27863,
		27863
	],
	"./filetype-css.svg": [
		44374,
		44374
	],
	"./filetype-csv.svg": [
		30995,
		30995
	],
	"./filetype-doc.svg": [
		90377,
		90377
	],
	"./filetype-docx.svg": [
		9791,
		9791
	],
	"./filetype-exe.svg": [
		63956,
		63956
	],
	"./filetype-gif.svg": [
		74372,
		74372
	],
	"./filetype-heic.svg": [
		83597,
		83597
	],
	"./filetype-html.svg": [
		91760,
		91760
	],
	"./filetype-java.svg": [
		22866,
		22866
	],
	"./filetype-jpg.svg": [
		2081,
		2081
	],
	"./filetype-js.svg": [
		46665,
		46665
	],
	"./filetype-json.svg": [
		83741,
		83741
	],
	"./filetype-jsx.svg": [
		63155,
		63155
	],
	"./filetype-key.svg": [
		79284,
		79284
	],
	"./filetype-m4p.svg": [
		77732,
		77732
	],
	"./filetype-md.svg": [
		75585,
		75585
	],
	"./filetype-mdx.svg": [
		68903,
		68903
	],
	"./filetype-mov.svg": [
		84948,
		84948
	],
	"./filetype-mp3.svg": [
		18076,
		18076
	],
	"./filetype-mp4.svg": [
		37536,
		37536
	],
	"./filetype-otf.svg": [
		69327,
		69327
	],
	"./filetype-pdf.svg": [
		3125,
		3125
	],
	"./filetype-php.svg": [
		48353,
		48353
	],
	"./filetype-png.svg": [
		83735,
		83735
	],
	"./filetype-ppt.svg": [
		51559,
		51559
	],
	"./filetype-pptx.svg": [
		28021,
		28021
	],
	"./filetype-psd.svg": [
		91737,
		91737
	],
	"./filetype-py.svg": [
		87909,
		87909
	],
	"./filetype-raw.svg": [
		9836,
		9836
	],
	"./filetype-rb.svg": [
		73546,
		73546
	],
	"./filetype-sass.svg": [
		39643,
		39643
	],
	"./filetype-scss.svg": [
		40668,
		40668
	],
	"./filetype-sh.svg": [
		33880,
		33880
	],
	"./filetype-sql.svg": [
		47549,
		47549
	],
	"./filetype-svg.svg": [
		91188,
		91188
	],
	"./filetype-tiff.svg": [
		57523,
		57523
	],
	"./filetype-tsx.svg": [
		75716,
		75716
	],
	"./filetype-ttf.svg": [
		18432,
		18432
	],
	"./filetype-txt.svg": [
		18054,
		18054
	],
	"./filetype-wav.svg": [
		10608,
		10608
	],
	"./filetype-woff.svg": [
		36268,
		36268
	],
	"./filetype-xls.svg": [
		40817,
		40817
	],
	"./filetype-xlsx.svg": [
		6385,
		6385
	],
	"./filetype-xml.svg": [
		31488,
		31488
	],
	"./filetype-yml.svg": [
		32584,
		32584
	],
	"./film.svg": [
		57594,
		57594
	],
	"./filter-circle-fill.svg": [
		67956,
		67956
	],
	"./filter-circle.svg": [
		32621,
		32621
	],
	"./filter-left.svg": [
		24723,
		24723
	],
	"./filter-right.svg": [
		24210,
		24210
	],
	"./filter-square-fill.svg": [
		38223,
		38223
	],
	"./filter-square.svg": [
		43302,
		43302
	],
	"./filter.svg": [
		28371,
		28371
	],
	"./fingerprint.svg": [
		82133,
		82133
	],
	"./fire.svg": [
		37581,
		37581
	],
	"./flag-fill.svg": [
		79124,
		79124
	],
	"./flag.svg": [
		72515,
		72515
	],
	"./floppy-fill.svg": [
		5528,
		5528
	],
	"./floppy.svg": [
		95342,
		95342
	],
	"./floppy2-fill.svg": [
		90601,
		90601
	],
	"./floppy2.svg": [
		55194,
		55194
	],
	"./flower1.svg": [
		29454,
		29454
	],
	"./flower2.svg": [
		14615,
		14615
	],
	"./flower3.svg": [
		90494,
		90494
	],
	"./folder-check.svg": [
		87628,
		87628
	],
	"./folder-fill.svg": [
		20718,
		20718
	],
	"./folder-minus.svg": [
		8672,
		8672
	],
	"./folder-plus.svg": [
		909,
		909
	],
	"./folder-symlink-fill.svg": [
		49779,
		49779
	],
	"./folder-symlink.svg": [
		87911,
		87911
	],
	"./folder-x.svg": [
		53300,
		53300
	],
	"./folder.svg": [
		34185,
		34185
	],
	"./folder2-open.svg": [
		39868,
		39868
	],
	"./folder2.svg": [
		60161,
		60161
	],
	"./fonts.svg": [
		77492,
		77492
	],
	"./forward-fill.svg": [
		18854,
		18854
	],
	"./forward.svg": [
		15590,
		15590
	],
	"./front.svg": [
		385,
		385
	],
	"./fuel-pump-diesel-fill.svg": [
		63009,
		63009
	],
	"./fuel-pump-diesel.svg": [
		6674,
		6674
	],
	"./fuel-pump-fill.svg": [
		94688,
		94688
	],
	"./fuel-pump.svg": [
		89531,
		89531
	],
	"./fullscreen-exit.svg": [
		86506,
		86506
	],
	"./fullscreen.svg": [
		63700,
		63700
	],
	"./funnel-fill.svg": [
		79173,
		79173
	],
	"./funnel.svg": [
		94337,
		94337
	],
	"./gear-fill.svg": [
		52564,
		52564
	],
	"./gear-wide-connected.svg": [
		5233,
		5233
	],
	"./gear-wide.svg": [
		86277,
		86277
	],
	"./gear.svg": [
		5761,
		5761
	],
	"./gem.svg": [
		32774,
		32774
	],
	"./gender-ambiguous.svg": [
		73167,
		73167
	],
	"./gender-female.svg": [
		27713,
		27713
	],
	"./gender-male.svg": [
		47711,
		47711
	],
	"./gender-neuter.svg": [
		64601,
		64601
	],
	"./gender-trans.svg": [
		49670,
		49670
	],
	"./geo-alt-fill.svg": [
		91420,
		91420
	],
	"./geo-alt.svg": [
		17569,
		17569
	],
	"./geo-fill.svg": [
		91647,
		91647
	],
	"./geo.svg": [
		28933,
		28933
	],
	"./gift-fill.svg": [
		55152,
		55152
	],
	"./gift.svg": [
		63409,
		63409
	],
	"./git.svg": [
		77407,
		77407
	],
	"./github.svg": [
		30321,
		30321
	],
	"./gitlab.svg": [
		25158,
		25158
	],
	"./globe-americas.svg": [
		45845,
		45845
	],
	"./globe-asia-australia.svg": [
		64095,
		64095
	],
	"./globe-central-south-asia.svg": [
		29041,
		29041
	],
	"./globe-europe-africa.svg": [
		52887,
		52887
	],
	"./globe.svg": [
		74619,
		74619
	],
	"./globe2.svg": [
		81684,
		81684
	],
	"./google-play.svg": [
		53020,
		53020
	],
	"./google.svg": [
		58519,
		58519
	],
	"./gpu-card.svg": [
		31715,
		31715
	],
	"./graph-down-arrow.svg": [
		52675,
		52675
	],
	"./graph-down.svg": [
		57309,
		57309
	],
	"./graph-up-arrow.svg": [
		69629,
		69629
	],
	"./graph-up.svg": [
		43095,
		43095
	],
	"./grid-1x2-fill.svg": [
		19981,
		19981
	],
	"./grid-1x2.svg": [
		19062,
		19062
	],
	"./grid-3x2-gap-fill.svg": [
		61382,
		61382
	],
	"./grid-3x2-gap.svg": [
		6357,
		6357
	],
	"./grid-3x2.svg": [
		77553,
		77553
	],
	"./grid-3x3-gap-fill.svg": [
		9419,
		9419
	],
	"./grid-3x3-gap.svg": [
		92679,
		92679
	],
	"./grid-3x3.svg": [
		12982,
		12982
	],
	"./grid-fill.svg": [
		45712,
		45712
	],
	"./grid.svg": [
		57417,
		57417
	],
	"./grip-horizontal.svg": [
		94605,
		94605
	],
	"./grip-vertical.svg": [
		59519,
		59519
	],
	"./h-circle-fill.svg": [
		5180,
		5180
	],
	"./h-circle.svg": [
		87150,
		87150
	],
	"./h-square-fill.svg": [
		62368,
		62368
	],
	"./h-square.svg": [
		70902,
		70902
	],
	"./hammer.svg": [
		32561,
		32561
	],
	"./hand-index-fill.svg": [
		19026,
		19026
	],
	"./hand-index-thumb-fill.svg": [
		98468,
		98468
	],
	"./hand-index-thumb.svg": [
		49943,
		49943
	],
	"./hand-index.svg": [
		89026,
		89026
	],
	"./hand-thumbs-down-fill.svg": [
		61931,
		61931
	],
	"./hand-thumbs-down.svg": [
		17103,
		17103
	],
	"./hand-thumbs-up-fill.svg": [
		23630,
		23630
	],
	"./hand-thumbs-up.svg": [
		68258,
		68258
	],
	"./handbag-fill.svg": [
		84794,
		84794
	],
	"./handbag.svg": [
		89792,
		89792
	],
	"./hash.svg": [
		19872,
		19872
	],
	"./hdd-fill.svg": [
		9361,
		9361
	],
	"./hdd-network-fill.svg": [
		36625,
		36625
	],
	"./hdd-network.svg": [
		57727,
		57727
	],
	"./hdd-rack-fill.svg": [
		48384,
		48384
	],
	"./hdd-rack.svg": [
		4551,
		4551
	],
	"./hdd-stack-fill.svg": [
		42036,
		42036
	],
	"./hdd-stack.svg": [
		19743,
		19743
	],
	"./hdd.svg": [
		77551,
		77551
	],
	"./hdmi-fill.svg": [
		42728,
		42728
	],
	"./hdmi.svg": [
		69540,
		69540
	],
	"./headphones.svg": [
		80822,
		80822
	],
	"./headset-vr.svg": [
		59718,
		59718
	],
	"./headset.svg": [
		32088,
		32088
	],
	"./heart-arrow.svg": [
		75655,
		75655
	],
	"./heart-fill.svg": [
		89481,
		89481
	],
	"./heart-half.svg": [
		23248,
		23248
	],
	"./heart-pulse-fill.svg": [
		61582,
		61582
	],
	"./heart-pulse.svg": [
		66330,
		66330
	],
	"./heart.svg": [
		20066,
		20066
	],
	"./heartbreak-fill.svg": [
		57159,
		57159
	],
	"./heartbreak.svg": [
		92009,
		92009
	],
	"./hearts.svg": [
		9888,
		9888
	],
	"./heptagon-fill.svg": [
		8034,
		8034
	],
	"./heptagon-half.svg": [
		18652,
		18652
	],
	"./heptagon.svg": [
		52951,
		52951
	],
	"./hexagon-fill.svg": [
		12552,
		12552
	],
	"./hexagon-half.svg": [
		20144,
		20144
	],
	"./hexagon.svg": [
		49933,
		49933
	],
	"./highlighter.svg": [
		30154,
		30154
	],
	"./highlights.svg": [
		76680,
		76680
	],
	"./hospital-fill.svg": [
		83846,
		83846
	],
	"./hospital.svg": [
		45068,
		45068
	],
	"./hourglass-bottom.svg": [
		1940,
		1940
	],
	"./hourglass-split.svg": [
		56455,
		56455
	],
	"./hourglass-top.svg": [
		89167,
		89167
	],
	"./hourglass.svg": [
		74528,
		74528
	],
	"./house-add-fill.svg": [
		44792,
		44792
	],
	"./house-add.svg": [
		15761,
		15761
	],
	"./house-check-fill.svg": [
		5325,
		5325
	],
	"./house-check.svg": [
		81906,
		81906
	],
	"./house-dash-fill.svg": [
		25562,
		25562
	],
	"./house-dash.svg": [
		93590,
		93590
	],
	"./house-door-fill.svg": [
		5436,
		5436
	],
	"./house-door.svg": [
		39742,
		39742
	],
	"./house-down-fill.svg": [
		35031,
		35031
	],
	"./house-down.svg": [
		47817,
		47817
	],
	"./house-exclamation-fill.svg": [
		87914,
		87914
	],
	"./house-exclamation.svg": [
		74799,
		74799
	],
	"./house-fill.svg": [
		80211,
		80211
	],
	"./house-gear-fill.svg": [
		62088,
		62088
	],
	"./house-gear.svg": [
		2454,
		2454
	],
	"./house-heart-fill.svg": [
		63386,
		63386
	],
	"./house-heart.svg": [
		70633,
		70633
	],
	"./house-lock-fill.svg": [
		70470,
		70470
	],
	"./house-lock.svg": [
		1976,
		1976
	],
	"./house-slash-fill.svg": [
		78223,
		78223
	],
	"./house-slash.svg": [
		72939,
		72939
	],
	"./house-up-fill.svg": [
		60444,
		60444
	],
	"./house-up.svg": [
		80704,
		80704
	],
	"./house-x-fill.svg": [
		2016,
		2016
	],
	"./house-x.svg": [
		49469,
		49469
	],
	"./house.svg": [
		27588,
		27588
	],
	"./houses-fill.svg": [
		57310,
		57310
	],
	"./houses.svg": [
		36784,
		36784
	],
	"./hr.svg": [
		82412,
		82412
	],
	"./hurricane.svg": [
		56916,
		56916
	],
	"./hypnotize.svg": [
		4891,
		4891
	],
	"./image-alt.svg": [
		99446,
		99446
	],
	"./image-fill.svg": [
		16670,
		16670
	],
	"./image.svg": [
		11951,
		11951
	],
	"./images.svg": [
		16514,
		16514
	],
	"./inbox-fill.svg": [
		50755,
		50755
	],
	"./inbox.svg": [
		98282,
		98282
	],
	"./inboxes-fill.svg": [
		4688,
		4688
	],
	"./inboxes.svg": [
		44514,
		44514
	],
	"./incognito.svg": [
		44294,
		44294
	],
	"./indent.svg": [
		66377,
		66377
	],
	"./infinity.svg": [
		42179,
		42179
	],
	"./info-circle-fill.svg": [
		34389,
		34389
	],
	"./info-circle.svg": [
		96525,
		96525
	],
	"./info-lg.svg": [
		2313,
		2313
	],
	"./info-square-fill.svg": [
		45172,
		45172
	],
	"./info-square.svg": [
		89790,
		89790
	],
	"./info.svg": [
		57112,
		57112
	],
	"./input-cursor-text.svg": [
		89603,
		89603
	],
	"./input-cursor.svg": [
		45871,
		45871
	],
	"./instagram.svg": [
		98553,
		98553
	],
	"./intersect.svg": [
		64547,
		64547
	],
	"./journal-album.svg": [
		22854,
		22854
	],
	"./journal-arrow-down.svg": [
		15057,
		15057
	],
	"./journal-arrow-up.svg": [
		43987,
		43987
	],
	"./journal-bookmark-fill.svg": [
		9705,
		9705
	],
	"./journal-bookmark.svg": [
		87515,
		87515
	],
	"./journal-check.svg": [
		60784,
		60784
	],
	"./journal-code.svg": [
		30572,
		30572
	],
	"./journal-medical.svg": [
		66004,
		66004
	],
	"./journal-minus.svg": [
		17969,
		17969
	],
	"./journal-plus.svg": [
		62510,
		62510
	],
	"./journal-richtext.svg": [
		45877,
		45877
	],
	"./journal-text.svg": [
		83821,
		83821
	],
	"./journal-x.svg": [
		61171,
		61171
	],
	"./journal.svg": [
		23899,
		23899
	],
	"./journals.svg": [
		74335,
		74335
	],
	"./joystick.svg": [
		44753,
		44753
	],
	"./justify-left.svg": [
		55697,
		55697
	],
	"./justify-right.svg": [
		37698,
		37698
	],
	"./justify.svg": [
		49019,
		49019
	],
	"./kanban-fill.svg": [
		81898,
		81898
	],
	"./kanban.svg": [
		24263,
		24263
	],
	"./key-fill.svg": [
		61722,
		61722
	],
	"./key.svg": [
		61764,
		61764
	],
	"./keyboard-fill.svg": [
		35586,
		35586
	],
	"./keyboard.svg": [
		92078,
		92078
	],
	"./ladder.svg": [
		84417,
		84417
	],
	"./lamp-fill.svg": [
		56697,
		56697
	],
	"./lamp.svg": [
		66323,
		66323
	],
	"./laptop-fill.svg": [
		87375,
		87375
	],
	"./laptop.svg": [
		97672,
		97672
	],
	"./layer-backward.svg": [
		35638,
		35638
	],
	"./layer-forward.svg": [
		52247,
		52247
	],
	"./layers-fill.svg": [
		24163,
		24163
	],
	"./layers-half.svg": [
		39692,
		39692
	],
	"./layers.svg": [
		77317,
		77317
	],
	"./layout-sidebar-inset-reverse.svg": [
		64008,
		64008
	],
	"./layout-sidebar-inset.svg": [
		46741,
		46741
	],
	"./layout-sidebar-reverse.svg": [
		90199,
		90199
	],
	"./layout-sidebar.svg": [
		96511,
		96511
	],
	"./layout-split.svg": [
		97263,
		97263
	],
	"./layout-text-sidebar-reverse.svg": [
		23021,
		23021
	],
	"./layout-text-sidebar.svg": [
		78930,
		78930
	],
	"./layout-text-window-reverse.svg": [
		50073,
		50073
	],
	"./layout-text-window.svg": [
		23997,
		23997
	],
	"./layout-three-columns.svg": [
		33129,
		33129
	],
	"./layout-wtf.svg": [
		339,
		339
	],
	"./life-preserver.svg": [
		9144,
		9144
	],
	"./lightbulb-fill.svg": [
		44049,
		44049
	],
	"./lightbulb-off-fill.svg": [
		62406,
		62406
	],
	"./lightbulb-off.svg": [
		1006,
		1006
	],
	"./lightbulb.svg": [
		41457,
		41457
	],
	"./lightning-charge-fill.svg": [
		95277,
		95277
	],
	"./lightning-charge.svg": [
		84545,
		84545
	],
	"./lightning-fill.svg": [
		60907,
		60907
	],
	"./lightning.svg": [
		48881,
		48881
	],
	"./line.svg": [
		8323,
		8323
	],
	"./link-45deg.svg": [
		61911,
		61911
	],
	"./link.svg": [
		1681,
		1681
	],
	"./linkedin.svg": [
		60139,
		60139
	],
	"./list-check.svg": [
		84007,
		84007
	],
	"./list-columns-reverse.svg": [
		64679,
		64679
	],
	"./list-columns.svg": [
		28803,
		28803
	],
	"./list-nested.svg": [
		86609,
		86609
	],
	"./list-ol.svg": [
		54862,
		54862
	],
	"./list-stars.svg": [
		65054,
		65054
	],
	"./list-task.svg": [
		98732,
		98732
	],
	"./list-ul.svg": [
		75357,
		75357
	],
	"./list.svg": [
		99781,
		99781
	],
	"./lock-fill.svg": [
		60703,
		60703
	],
	"./lock.svg": [
		5510,
		5510
	],
	"./luggage-fill.svg": [
		64288,
		64288
	],
	"./luggage.svg": [
		92230,
		92230
	],
	"./lungs-fill.svg": [
		82776,
		82776
	],
	"./lungs.svg": [
		75361,
		75361
	],
	"./magic.svg": [
		96151,
		96151
	],
	"./magnet-fill.svg": [
		55285,
		55285
	],
	"./magnet.svg": [
		84302,
		84302
	],
	"./mailbox-flag.svg": [
		914,
		914
	],
	"./mailbox.svg": [
		47442,
		47442
	],
	"./mailbox2-flag.svg": [
		94634,
		94634
	],
	"./mailbox2.svg": [
		78587,
		78587
	],
	"./map-fill.svg": [
		85747,
		85747
	],
	"./map.svg": [
		47880,
		47880
	],
	"./markdown-fill.svg": [
		58718,
		58718
	],
	"./markdown.svg": [
		83247,
		83247
	],
	"./marker-tip.svg": [
		37918,
		37918
	],
	"./mask.svg": [
		99409,
		99409
	],
	"./mastodon.svg": [
		92435,
		92435
	],
	"./medium.svg": [
		18599,
		18599
	],
	"./megaphone-fill.svg": [
		38882,
		38882
	],
	"./megaphone.svg": [
		45337,
		45337
	],
	"./memory.svg": [
		72023,
		72023
	],
	"./menu-app-fill.svg": [
		57539,
		57539
	],
	"./menu-app.svg": [
		10985,
		10985
	],
	"./menu-button-fill.svg": [
		24728,
		24728
	],
	"./menu-button-wide-fill.svg": [
		45138,
		45138
	],
	"./menu-button-wide.svg": [
		56243,
		56243
	],
	"./menu-button.svg": [
		87424,
		87424
	],
	"./menu-down.svg": [
		85960,
		85960
	],
	"./menu-up.svg": [
		59143,
		59143
	],
	"./messenger.svg": [
		47256,
		47256
	],
	"./meta.svg": [
		76149,
		76149
	],
	"./mic-fill.svg": [
		87382,
		87382
	],
	"./mic-mute-fill.svg": [
		49620,
		49620
	],
	"./mic-mute.svg": [
		6817,
		6817
	],
	"./mic.svg": [
		87700,
		87700
	],
	"./microsoft-teams.svg": [
		40078,
		40078
	],
	"./microsoft.svg": [
		84393,
		84393
	],
	"./minecart-loaded.svg": [
		41604,
		41604
	],
	"./minecart.svg": [
		80258,
		80258
	],
	"./modem-fill.svg": [
		61636,
		61636
	],
	"./modem.svg": [
		23025,
		23025
	],
	"./moisture.svg": [
		41723,
		41723
	],
	"./moon-fill.svg": [
		41856,
		41856
	],
	"./moon-stars-fill.svg": [
		54900,
		54900
	],
	"./moon-stars.svg": [
		69938,
		69938
	],
	"./moon.svg": [
		67689,
		67689
	],
	"./mortarboard-fill.svg": [
		64582,
		89556
	],
	"./mortarboard.svg": [
		31828,
		31828
	],
	"./motherboard-fill.svg": [
		74911,
		74911
	],
	"./motherboard.svg": [
		23741,
		23741
	],
	"./mouse-fill.svg": [
		96967,
		96967
	],
	"./mouse.svg": [
		13758,
		13758
	],
	"./mouse2-fill.svg": [
		93113,
		93113
	],
	"./mouse2.svg": [
		70251,
		70251
	],
	"./mouse3-fill.svg": [
		14354,
		14354
	],
	"./mouse3.svg": [
		53503,
		53503
	],
	"./music-note-beamed.svg": [
		29092,
		29092
	],
	"./music-note-list.svg": [
		5523,
		5523
	],
	"./music-note.svg": [
		70684,
		70684
	],
	"./music-player-fill.svg": [
		46110,
		46110
	],
	"./music-player.svg": [
		85104,
		85104
	],
	"./newspaper.svg": [
		12546,
		12546
	],
	"./nintendo-switch.svg": [
		5826,
		5826
	],
	"./node-minus-fill.svg": [
		66624,
		66624
	],
	"./node-minus.svg": [
		65376,
		65376
	],
	"./node-plus-fill.svg": [
		208,
		208
	],
	"./node-plus.svg": [
		42806,
		42806
	],
	"./noise-reduction.svg": [
		48318,
		48318
	],
	"./nut-fill.svg": [
		29793,
		29793
	],
	"./nut.svg": [
		63593,
		63593
	],
	"./nvidia.svg": [
		30290,
		30290
	],
	"./nvme-fill.svg": [
		10585,
		10585
	],
	"./nvme.svg": [
		81486,
		81486
	],
	"./octagon-fill.svg": [
		34883,
		34883
	],
	"./octagon-half.svg": [
		26822,
		26822
	],
	"./octagon.svg": [
		62089,
		62089
	],
	"./opencollective.svg": [
		82767,
		82767
	],
	"./optical-audio-fill.svg": [
		46751,
		46751
	],
	"./optical-audio.svg": [
		60581,
		60581
	],
	"./option.svg": [
		35105,
		35105
	],
	"./outlet.svg": [
		595,
		595
	],
	"./p-circle-fill.svg": [
		89050,
		89050
	],
	"./p-circle.svg": [
		14969,
		14969
	],
	"./p-square-fill.svg": [
		95876,
		95876
	],
	"./p-square.svg": [
		54514,
		54514
	],
	"./paint-bucket.svg": [
		68563,
		68563
	],
	"./palette-fill.svg": [
		56140,
		56140
	],
	"./palette.svg": [
		42825,
		42825
	],
	"./palette2.svg": [
		10563,
		10563
	],
	"./paperclip.svg": [
		10133,
		10133
	],
	"./paragraph.svg": [
		9171,
		9171
	],
	"./pass-fill.svg": [
		36167,
		36167
	],
	"./pass.svg": [
		1822,
		1822
	],
	"./passport-fill.svg": [
		15292,
		15292
	],
	"./passport.svg": [
		28848,
		28848
	],
	"./patch-check-fill.svg": [
		98156,
		98156
	],
	"./patch-check.svg": [
		88065,
		88065
	],
	"./patch-exclamation-fill.svg": [
		16659,
		16659
	],
	"./patch-exclamation.svg": [
		82651,
		82651
	],
	"./patch-minus-fill.svg": [
		18430,
		18430
	],
	"./patch-minus.svg": [
		27087,
		27087
	],
	"./patch-plus-fill.svg": [
		89048,
		89048
	],
	"./patch-plus.svg": [
		64422,
		64422
	],
	"./patch-question-fill.svg": [
		6754,
		6754
	],
	"./patch-question.svg": [
		80357,
		80357
	],
	"./pause-btn-fill.svg": [
		62309,
		62309
	],
	"./pause-btn.svg": [
		29001,
		29001
	],
	"./pause-circle-fill.svg": [
		1805,
		1805
	],
	"./pause-circle.svg": [
		98162,
		98162
	],
	"./pause-fill.svg": [
		97137,
		97137
	],
	"./pause.svg": [
		2017,
		2017
	],
	"./paypal.svg": [
		7814,
		7814
	],
	"./pc-display-horizontal.svg": [
		41475,
		41475
	],
	"./pc-display.svg": [
		63643,
		63643
	],
	"./pc-horizontal.svg": [
		17324,
		17324
	],
	"./pc.svg": [
		92241,
		92241
	],
	"./pci-card-network.svg": [
		75663,
		75663
	],
	"./pci-card-sound.svg": [
		48830,
		48830
	],
	"./pci-card.svg": [
		87623,
		87623
	],
	"./peace-fill.svg": [
		62898,
		62898
	],
	"./peace.svg": [
		6878,
		6878
	],
	"./pen-fill.svg": [
		61679,
		61679
	],
	"./pen.svg": [
		87818,
		87818
	],
	"./pencil-fill.svg": [
		17580,
		17580
	],
	"./pencil-square.svg": [
		24080,
		24080
	],
	"./pencil.svg": [
		19089,
		19089
	],
	"./pentagon-fill.svg": [
		83019,
		83019
	],
	"./pentagon-half.svg": [
		51805,
		51805
	],
	"./pentagon.svg": [
		79565,
		79565
	],
	"./people-fill.svg": [
		53464,
		53464
	],
	"./people.svg": [
		30359,
		30359
	],
	"./percent.svg": [
		94302,
		94302
	],
	"./person-add.svg": [
		93307,
		93307
	],
	"./person-arms-up.svg": [
		91304,
		91304
	],
	"./person-badge-fill.svg": [
		37087,
		37087
	],
	"./person-badge.svg": [
		94478,
		94478
	],
	"./person-bounding-box.svg": [
		90037,
		90037
	],
	"./person-check-fill.svg": [
		37228,
		37228
	],
	"./person-check.svg": [
		14622,
		14622
	],
	"./person-circle.svg": [
		48741,
		48741
	],
	"./person-dash-fill.svg": [
		45415,
		45415
	],
	"./person-dash.svg": [
		67329,
		67329
	],
	"./person-down.svg": [
		4247,
		4247
	],
	"./person-exclamation.svg": [
		9410,
		9410
	],
	"./person-fill-add.svg": [
		2964,
		2964
	],
	"./person-fill-check.svg": [
		12671,
		12671
	],
	"./person-fill-dash.svg": [
		9898,
		9898
	],
	"./person-fill-down.svg": [
		36802,
		36802
	],
	"./person-fill-exclamation.svg": [
		49372,
		49372
	],
	"./person-fill-gear.svg": [
		85428,
		85428
	],
	"./person-fill-lock.svg": [
		41608,
		41608
	],
	"./person-fill-slash.svg": [
		70610,
		70610
	],
	"./person-fill-up.svg": [
		95850,
		95850
	],
	"./person-fill-x.svg": [
		98911,
		98911
	],
	"./person-fill.svg": [
		81082,
		81082
	],
	"./person-gear.svg": [
		60097,
		60097
	],
	"./person-heart.svg": [
		72346,
		72346
	],
	"./person-hearts.svg": [
		13617,
		13617
	],
	"./person-lines-fill.svg": [
		77379,
		77379
	],
	"./person-lock.svg": [
		89466,
		89466
	],
	"./person-plus-fill.svg": [
		75314,
		75314
	],
	"./person-plus.svg": [
		85604,
		85604
	],
	"./person-raised-hand.svg": [
		17249,
		17249
	],
	"./person-rolodex.svg": [
		19676,
		19676
	],
	"./person-slash.svg": [
		81822,
		81822
	],
	"./person-square.svg": [
		9151,
		9151
	],
	"./person-standing-dress.svg": [
		67119,
		67119
	],
	"./person-standing.svg": [
		30162,
		30162
	],
	"./person-up.svg": [
		18678,
		18678
	],
	"./person-vcard-fill.svg": [
		12836,
		12836
	],
	"./person-vcard.svg": [
		64652,
		64652
	],
	"./person-video.svg": [
		43933,
		43933
	],
	"./person-video2.svg": [
		25732,
		25732
	],
	"./person-video3.svg": [
		18121,
		18121
	],
	"./person-walking.svg": [
		980,
		980
	],
	"./person-wheelchair.svg": [
		9059,
		9059
	],
	"./person-workspace.svg": [
		51222,
		51222
	],
	"./person-x-fill.svg": [
		86755,
		86755
	],
	"./person-x.svg": [
		25962,
		25962
	],
	"./person.svg": [
		67395,
		67395
	],
	"./phone-fill.svg": [
		11448,
		11448
	],
	"./phone-flip.svg": [
		36964,
		36964
	],
	"./phone-landscape-fill.svg": [
		57044,
		57044
	],
	"./phone-landscape.svg": [
		35352,
		35352
	],
	"./phone-vibrate-fill.svg": [
		86531,
		86531
	],
	"./phone-vibrate.svg": [
		2080,
		2080
	],
	"./phone.svg": [
		17801,
		17801
	],
	"./pie-chart-fill.svg": [
		54426,
		54426
	],
	"./pie-chart.svg": [
		27216,
		27216
	],
	"./piggy-bank-fill.svg": [
		40989,
		40989
	],
	"./piggy-bank.svg": [
		22232,
		22232
	],
	"./pin-angle-fill.svg": [
		20458,
		20458
	],
	"./pin-angle.svg": [
		92286,
		92286
	],
	"./pin-fill.svg": [
		20074,
		20074
	],
	"./pin-map-fill.svg": [
		75484,
		75484
	],
	"./pin-map.svg": [
		33838,
		33838
	],
	"./pin.svg": [
		37833,
		37833
	],
	"./pinterest.svg": [
		78205,
		78205
	],
	"./pip-fill.svg": [
		12191,
		12191
	],
	"./pip.svg": [
		36759,
		36759
	],
	"./play-btn-fill.svg": [
		57639,
		57639
	],
	"./play-btn.svg": [
		24314,
		24314
	],
	"./play-circle-fill.svg": [
		10721,
		10721
	],
	"./play-circle.svg": [
		40479,
		40479
	],
	"./play-fill.svg": [
		32930,
		32930
	],
	"./play.svg": [
		34218,
		34218
	],
	"./playstation.svg": [
		10676,
		10676
	],
	"./plug-fill.svg": [
		96512,
		96512
	],
	"./plug.svg": [
		77821,
		77821
	],
	"./plugin.svg": [
		27019,
		27019
	],
	"./plus-circle-dotted.svg": [
		7081,
		7081
	],
	"./plus-circle-fill.svg": [
		77557,
		77557
	],
	"./plus-circle.svg": [
		79614,
		79614
	],
	"./plus-lg.svg": [
		31702,
		31702
	],
	"./plus-slash-minus.svg": [
		92832,
		92832
	],
	"./plus-square-dotted.svg": [
		21368,
		21368
	],
	"./plus-square-fill.svg": [
		27337,
		27337
	],
	"./plus-square.svg": [
		23642,
		23642
	],
	"./plus.svg": [
		95207,
		95207
	],
	"./postage-fill.svg": [
		6587,
		6587
	],
	"./postage-heart-fill.svg": [
		43645,
		43645
	],
	"./postage-heart.svg": [
		51826,
		51826
	],
	"./postage.svg": [
		35427,
		35427
	],
	"./postcard-fill.svg": [
		36700,
		36700
	],
	"./postcard-heart-fill.svg": [
		62337,
		62337
	],
	"./postcard-heart.svg": [
		35760,
		35760
	],
	"./postcard.svg": [
		53229,
		53229
	],
	"./power.svg": [
		21551,
		21551
	],
	"./prescription.svg": [
		86878,
		86878
	],
	"./prescription2.svg": [
		99331,
		99331
	],
	"./printer-fill.svg": [
		21386,
		21386
	],
	"./printer.svg": [
		82103,
		82103
	],
	"./projector-fill.svg": [
		26922,
		26922
	],
	"./projector.svg": [
		38200,
		38200
	],
	"./puzzle-fill.svg": [
		24946,
		24946
	],
	"./puzzle.svg": [
		62141,
		62141
	],
	"./qr-code-scan.svg": [
		83078,
		83078
	],
	"./qr-code.svg": [
		70812,
		70812
	],
	"./question-circle-fill.svg": [
		31223,
		31223
	],
	"./question-circle.svg": [
		76093,
		76093
	],
	"./question-diamond-fill.svg": [
		14835,
		14835
	],
	"./question-diamond.svg": [
		14002,
		14002
	],
	"./question-lg.svg": [
		24230,
		24230
	],
	"./question-octagon-fill.svg": [
		38977,
		38977
	],
	"./question-octagon.svg": [
		56231,
		56231
	],
	"./question-square-fill.svg": [
		95996,
		95996
	],
	"./question-square.svg": [
		28985,
		28985
	],
	"./question.svg": [
		75098,
		75098
	],
	"./quora.svg": [
		4675,
		4675
	],
	"./quote.svg": [
		43111,
		43111
	],
	"./r-circle-fill.svg": [
		46631,
		46631
	],
	"./r-circle.svg": [
		19249,
		19249
	],
	"./r-square-fill.svg": [
		76006,
		76006
	],
	"./r-square.svg": [
		63667,
		63667
	],
	"./radar.svg": [
		12517,
		12517
	],
	"./radioactive.svg": [
		19525,
		19525
	],
	"./rainbow.svg": [
		61949,
		61949
	],
	"./receipt-cutoff.svg": [
		60524,
		60524
	],
	"./receipt.svg": [
		21467,
		21467
	],
	"./reception-0.svg": [
		67950,
		67950
	],
	"./reception-1.svg": [
		3760,
		3760
	],
	"./reception-2.svg": [
		80950,
		80950
	],
	"./reception-3.svg": [
		13097,
		13097
	],
	"./reception-4.svg": [
		55872,
		55872
	],
	"./record-btn-fill.svg": [
		17170,
		17170
	],
	"./record-btn.svg": [
		25289,
		25289
	],
	"./record-circle-fill.svg": [
		36754,
		36754
	],
	"./record-circle.svg": [
		70193,
		70193
	],
	"./record-fill.svg": [
		29244,
		29244
	],
	"./record.svg": [
		41001,
		41001
	],
	"./record2-fill.svg": [
		70594,
		70594
	],
	"./record2.svg": [
		13616,
		13616
	],
	"./recycle.svg": [
		32829,
		32829
	],
	"./reddit.svg": [
		1229,
		1229
	],
	"./regex.svg": [
		44070,
		44070
	],
	"./repeat-1.svg": [
		16987,
		16987
	],
	"./repeat.svg": [
		81351,
		81351
	],
	"./reply-all-fill.svg": [
		43480,
		43480
	],
	"./reply-all.svg": [
		97173,
		97173
	],
	"./reply-fill.svg": [
		69731,
		69731
	],
	"./reply.svg": [
		20567,
		20567
	],
	"./rewind-btn-fill.svg": [
		85166,
		85166
	],
	"./rewind-btn.svg": [
		48029,
		48029
	],
	"./rewind-circle-fill.svg": [
		21822,
		21822
	],
	"./rewind-circle.svg": [
		39888,
		39888
	],
	"./rewind-fill.svg": [
		1994,
		1994
	],
	"./rewind.svg": [
		44622,
		44622
	],
	"./robot.svg": [
		69164,
		69164
	],
	"./rocket-fill.svg": [
		28588,
		28588
	],
	"./rocket-takeoff-fill.svg": [
		48963,
		48963
	],
	"./rocket-takeoff.svg": [
		98399,
		98399
	],
	"./rocket.svg": [
		72872,
		72872
	],
	"./router-fill.svg": [
		80228,
		80228
	],
	"./router.svg": [
		64433,
		64433
	],
	"./rss-fill.svg": [
		8000,
		8000
	],
	"./rss.svg": [
		89392,
		89392
	],
	"./rulers.svg": [
		31871,
		31871
	],
	"./safe-fill.svg": [
		51217,
		51217
	],
	"./safe.svg": [
		26412,
		26412
	],
	"./safe2-fill.svg": [
		679,
		679
	],
	"./safe2.svg": [
		45442,
		45442
	],
	"./save-fill.svg": [
		11883,
		11883
	],
	"./save.svg": [
		6209,
		6209
	],
	"./save2-fill.svg": [
		8105,
		8105
	],
	"./save2.svg": [
		84145,
		84145
	],
	"./scissors.svg": [
		30003,
		30003
	],
	"./scooter.svg": [
		8312,
		8312
	],
	"./screwdriver.svg": [
		82078,
		82078
	],
	"./sd-card-fill.svg": [
		18996,
		18996
	],
	"./sd-card.svg": [
		57093,
		57093
	],
	"./search-heart-fill.svg": [
		2963,
		2963
	],
	"./search-heart.svg": [
		9274,
		9274
	],
	"./search.svg": [
		49697,
		49697
	],
	"./segmented-nav.svg": [
		2475,
		2475
	],
	"./send-arrow-down-fill.svg": [
		36548,
		36548
	],
	"./send-arrow-down.svg": [
		62547,
		62547
	],
	"./send-arrow-up-fill.svg": [
		30494,
		30494
	],
	"./send-arrow-up.svg": [
		47151,
		47151
	],
	"./send-check-fill.svg": [
		95555,
		95555
	],
	"./send-check.svg": [
		51994,
		51994
	],
	"./send-dash-fill.svg": [
		13950,
		13950
	],
	"./send-dash.svg": [
		96693,
		96693
	],
	"./send-exclamation-fill.svg": [
		87285,
		87285
	],
	"./send-exclamation.svg": [
		5959,
		5959
	],
	"./send-fill.svg": [
		40414,
		40414
	],
	"./send-plus-fill.svg": [
		24717,
		24717
	],
	"./send-plus.svg": [
		38319,
		38319
	],
	"./send-slash-fill.svg": [
		38072,
		38072
	],
	"./send-slash.svg": [
		45158,
		45158
	],
	"./send-x-fill.svg": [
		3045,
		3045
	],
	"./send-x.svg": [
		87663,
		87663
	],
	"./send.svg": [
		29859,
		29859
	],
	"./server.svg": [
		52186,
		52186
	],
	"./shadows.svg": [
		52324,
		52324
	],
	"./share-fill.svg": [
		75593,
		75593
	],
	"./share.svg": [
		96001,
		96001
	],
	"./shield-check.svg": [
		89670,
		89670
	],
	"./shield-exclamation.svg": [
		64719,
		64719
	],
	"./shield-fill-check.svg": [
		94288,
		94288
	],
	"./shield-fill-exclamation.svg": [
		55638,
		55638
	],
	"./shield-fill-minus.svg": [
		13329,
		13329
	],
	"./shield-fill-plus.svg": [
		40238,
		40238
	],
	"./shield-fill-x.svg": [
		19982,
		19982
	],
	"./shield-fill.svg": [
		13197,
		13197
	],
	"./shield-lock-fill.svg": [
		69475,
		69475
	],
	"./shield-lock.svg": [
		77877,
		77877
	],
	"./shield-minus.svg": [
		6944,
		6944
	],
	"./shield-plus.svg": [
		29200,
		29200
	],
	"./shield-shaded.svg": [
		19437,
		19437
	],
	"./shield-slash-fill.svg": [
		88015,
		88015
	],
	"./shield-slash.svg": [
		4640,
		4640
	],
	"./shield-x.svg": [
		20433,
		20433
	],
	"./shield.svg": [
		38578,
		38578
	],
	"./shift-fill.svg": [
		43345,
		43345
	],
	"./shift.svg": [
		67804,
		67804
	],
	"./shop-window.svg": [
		80838,
		80838
	],
	"./shop.svg": [
		54660,
		54660
	],
	"./shuffle.svg": [
		63611,
		63611
	],
	"./sign-dead-end-fill.svg": [
		32144,
		32144
	],
	"./sign-dead-end.svg": [
		63211,
		63211
	],
	"./sign-do-not-enter-fill.svg": [
		48290,
		48290
	],
	"./sign-do-not-enter.svg": [
		98694,
		98694
	],
	"./sign-intersection-fill.svg": [
		88074,
		88074
	],
	"./sign-intersection-side-fill.svg": [
		10736,
		10736
	],
	"./sign-intersection-side.svg": [
		63473,
		63473
	],
	"./sign-intersection-t-fill.svg": [
		12245,
		12245
	],
	"./sign-intersection-t.svg": [
		48357,
		48357
	],
	"./sign-intersection-y-fill.svg": [
		63996,
		63996
	],
	"./sign-intersection-y.svg": [
		44812,
		44812
	],
	"./sign-intersection.svg": [
		13517,
		13517
	],
	"./sign-merge-left-fill.svg": [
		46038,
		46038
	],
	"./sign-merge-left.svg": [
		16704,
		16704
	],
	"./sign-merge-right-fill.svg": [
		32046,
		32046
	],
	"./sign-merge-right.svg": [
		93459,
		93459
	],
	"./sign-no-left-turn-fill.svg": [
		53270,
		53270
	],
	"./sign-no-left-turn.svg": [
		83913,
		83913
	],
	"./sign-no-parking-fill.svg": [
		30862,
		30862
	],
	"./sign-no-parking.svg": [
		98219,
		98219
	],
	"./sign-no-right-turn-fill.svg": [
		12615,
		12615
	],
	"./sign-no-right-turn.svg": [
		71135,
		71135
	],
	"./sign-railroad-fill.svg": [
		27613,
		27613
	],
	"./sign-railroad.svg": [
		96950,
		96950
	],
	"./sign-stop-fill.svg": [
		49210,
		49210
	],
	"./sign-stop-lights-fill.svg": [
		33873,
		33873
	],
	"./sign-stop-lights.svg": [
		50080,
		50080
	],
	"./sign-stop.svg": [
		8186,
		8186
	],
	"./sign-turn-left-fill.svg": [
		76257,
		76257
	],
	"./sign-turn-left.svg": [
		13833,
		13833
	],
	"./sign-turn-right-fill.svg": [
		6237,
		6237
	],
	"./sign-turn-right.svg": [
		83403,
		83403
	],
	"./sign-turn-slight-left-fill.svg": [
		29998,
		29998
	],
	"./sign-turn-slight-left.svg": [
		46299,
		46299
	],
	"./sign-turn-slight-right-fill.svg": [
		98408,
		98408
	],
	"./sign-turn-slight-right.svg": [
		84626,
		84626
	],
	"./sign-yield-fill.svg": [
		87708,
		87708
	],
	"./sign-yield.svg": [
		64721,
		64721
	],
	"./signal.svg": [
		92783,
		92783
	],
	"./signpost-2-fill.svg": [
		25606,
		25606
	],
	"./signpost-2.svg": [
		20515,
		20515
	],
	"./signpost-fill.svg": [
		27677,
		27677
	],
	"./signpost-split-fill.svg": [
		7168,
		7168
	],
	"./signpost-split.svg": [
		59629,
		59629
	],
	"./signpost.svg": [
		29382,
		29382
	],
	"./sim-fill.svg": [
		4343,
		4343
	],
	"./sim-slash-fill.svg": [
		60847,
		60847
	],
	"./sim-slash.svg": [
		34083,
		34083
	],
	"./sim.svg": [
		33622,
		33622
	],
	"./sina-weibo.svg": [
		75001,
		75001
	],
	"./skip-backward-btn-fill.svg": [
		4461,
		4461
	],
	"./skip-backward-btn.svg": [
		64171,
		64171
	],
	"./skip-backward-circle-fill.svg": [
		32137,
		32137
	],
	"./skip-backward-circle.svg": [
		34038,
		34038
	],
	"./skip-backward-fill.svg": [
		21543,
		21543
	],
	"./skip-backward.svg": [
		20688,
		20688
	],
	"./skip-end-btn-fill.svg": [
		11694,
		11694
	],
	"./skip-end-btn.svg": [
		95631,
		95631
	],
	"./skip-end-circle-fill.svg": [
		97544,
		97544
	],
	"./skip-end-circle.svg": [
		37990,
		37990
	],
	"./skip-end-fill.svg": [
		73023,
		73023
	],
	"./skip-end.svg": [
		65633,
		65633
	],
	"./skip-forward-btn-fill.svg": [
		33817,
		33817
	],
	"./skip-forward-btn.svg": [
		28587,
		28587
	],
	"./skip-forward-circle-fill.svg": [
		90237,
		90237
	],
	"./skip-forward-circle.svg": [
		86800,
		86800
	],
	"./skip-forward-fill.svg": [
		72267,
		72267
	],
	"./skip-forward.svg": [
		67418,
		67418
	],
	"./skip-start-btn-fill.svg": [
		72856,
		72856
	],
	"./skip-start-btn.svg": [
		99595,
		99595
	],
	"./skip-start-circle-fill.svg": [
		80512,
		80512
	],
	"./skip-start-circle.svg": [
		15029,
		15029
	],
	"./skip-start-fill.svg": [
		49653,
		49653
	],
	"./skip-start.svg": [
		62225,
		62225
	],
	"./skype.svg": [
		20690,
		20690
	],
	"./slack.svg": [
		39190,
		39190
	],
	"./slash-circle-fill.svg": [
		35702,
		35702
	],
	"./slash-circle.svg": [
		21146,
		21146
	],
	"./slash-lg.svg": [
		18616,
		18616
	],
	"./slash-square-fill.svg": [
		23343,
		23343
	],
	"./slash-square.svg": [
		30803,
		30803
	],
	"./slash.svg": [
		48287,
		48287
	],
	"./sliders.svg": [
		51144,
		51144
	],
	"./sliders2-vertical.svg": [
		45342,
		45342
	],
	"./sliders2.svg": [
		11639,
		11639
	],
	"./smartwatch.svg": [
		9156,
		9156
	],
	"./snapchat.svg": [
		16735,
		16735
	],
	"./snow.svg": [
		39655,
		39655
	],
	"./snow2.svg": [
		21487,
		21487
	],
	"./snow3.svg": [
		15259,
		15259
	],
	"./sort-alpha-down-alt.svg": [
		47003,
		47003
	],
	"./sort-alpha-down.svg": [
		62338,
		62338
	],
	"./sort-alpha-up-alt.svg": [
		2384,
		2384
	],
	"./sort-alpha-up.svg": [
		11847,
		11847
	],
	"./sort-down-alt.svg": [
		28096,
		28096
	],
	"./sort-down.svg": [
		54549,
		54549
	],
	"./sort-numeric-down-alt.svg": [
		95519,
		95519
	],
	"./sort-numeric-down.svg": [
		71687,
		71687
	],
	"./sort-numeric-up-alt.svg": [
		87844,
		87844
	],
	"./sort-numeric-up.svg": [
		26239,
		26239
	],
	"./sort-up-alt.svg": [
		39574,
		39574
	],
	"./sort-up.svg": [
		90278,
		90278
	],
	"./soundwave.svg": [
		56814,
		56814
	],
	"./sourceforge.svg": [
		70418,
		70418
	],
	"./speaker-fill.svg": [
		51527,
		51527
	],
	"./speaker.svg": [
		56332,
		56332
	],
	"./speedometer.svg": [
		74293,
		74293
	],
	"./speedometer2.svg": [
		622,
		622
	],
	"./spellcheck.svg": [
		16369,
		16369
	],
	"./spotify.svg": [
		90658,
		90658
	],
	"./square-fill.svg": [
		94785,
		94785
	],
	"./square-half.svg": [
		99968,
		99968
	],
	"./square.svg": [
		78597,
		78597
	],
	"./stack-overflow.svg": [
		56345,
		56345
	],
	"./stack.svg": [
		46858,
		46858
	],
	"./star-fill.svg": [
		36564,
		36564
	],
	"./star-half.svg": [
		29849,
		29849
	],
	"./star.svg": [
		72535,
		72535
	],
	"./stars.svg": [
		84862,
		84862
	],
	"./steam.svg": [
		58114,
		58114
	],
	"./stickies-fill.svg": [
		36267,
		36267
	],
	"./stickies.svg": [
		36009,
		36009
	],
	"./sticky-fill.svg": [
		93684,
		93684
	],
	"./sticky.svg": [
		71492,
		71492
	],
	"./stop-btn-fill.svg": [
		34606,
		34606
	],
	"./stop-btn.svg": [
		6194,
		6194
	],
	"./stop-circle-fill.svg": [
		8250,
		8250
	],
	"./stop-circle.svg": [
		12540,
		12540
	],
	"./stop-fill.svg": [
		55216,
		55216
	],
	"./stop.svg": [
		6597,
		6597
	],
	"./stoplights-fill.svg": [
		11713,
		11713
	],
	"./stoplights.svg": [
		79732,
		79732
	],
	"./stopwatch-fill.svg": [
		36129,
		36129
	],
	"./stopwatch.svg": [
		91722,
		91722
	],
	"./strava.svg": [
		87803,
		87803
	],
	"./stripe.svg": [
		86369,
		86369
	],
	"./subscript.svg": [
		45437,
		45437
	],
	"./substack.svg": [
		52049,
		52049
	],
	"./subtract.svg": [
		59369,
		59369
	],
	"./suit-club-fill.svg": [
		87345,
		87345
	],
	"./suit-club.svg": [
		20024,
		20024
	],
	"./suit-diamond-fill.svg": [
		28114,
		28114
	],
	"./suit-diamond.svg": [
		73463,
		73463
	],
	"./suit-heart-fill.svg": [
		9942,
		9942
	],
	"./suit-heart.svg": [
		87955,
		87955
	],
	"./suit-spade-fill.svg": [
		21375,
		21375
	],
	"./suit-spade.svg": [
		51291,
		51291
	],
	"./suitcase-fill.svg": [
		27067,
		27067
	],
	"./suitcase-lg-fill.svg": [
		70898,
		70898
	],
	"./suitcase-lg.svg": [
		17627,
		17627
	],
	"./suitcase.svg": [
		46742,
		46742
	],
	"./suitcase2-fill.svg": [
		41397,
		41397
	],
	"./suitcase2.svg": [
		48809,
		48809
	],
	"./sun-fill.svg": [
		91211,
		91211
	],
	"./sun.svg": [
		44188,
		44188
	],
	"./sunglasses.svg": [
		83488,
		83488
	],
	"./sunrise-fill.svg": [
		8714,
		8714
	],
	"./sunrise.svg": [
		48259,
		48259
	],
	"./sunset-fill.svg": [
		74128,
		74128
	],
	"./sunset.svg": [
		3883,
		3883
	],
	"./superscript.svg": [
		41747,
		41747
	],
	"./symmetry-horizontal.svg": [
		11874,
		11874
	],
	"./symmetry-vertical.svg": [
		15910,
		15910
	],
	"./table.svg": [
		4738,
		4738
	],
	"./tablet-fill.svg": [
		68469,
		68469
	],
	"./tablet-landscape-fill.svg": [
		46374,
		46374
	],
	"./tablet-landscape.svg": [
		96073,
		96073
	],
	"./tablet.svg": [
		99722,
		99722
	],
	"./tag-fill.svg": [
		12387,
		12387
	],
	"./tag.svg": [
		95014,
		95014
	],
	"./tags-fill.svg": [
		96548,
		96548
	],
	"./tags.svg": [
		12519,
		12519
	],
	"./taxi-front-fill.svg": [
		8075,
		8075
	],
	"./taxi-front.svg": [
		53180,
		53180
	],
	"./telegram.svg": [
		58441,
		58441
	],
	"./telephone-fill.svg": [
		63997,
		63997
	],
	"./telephone-forward-fill.svg": [
		91453,
		91453
	],
	"./telephone-forward.svg": [
		86671,
		86671
	],
	"./telephone-inbound-fill.svg": [
		82032,
		82032
	],
	"./telephone-inbound.svg": [
		42783,
		42783
	],
	"./telephone-minus-fill.svg": [
		27806,
		27806
	],
	"./telephone-minus.svg": [
		91082,
		91082
	],
	"./telephone-outbound-fill.svg": [
		82430,
		82430
	],
	"./telephone-outbound.svg": [
		18610,
		18610
	],
	"./telephone-plus-fill.svg": [
		85833,
		85833
	],
	"./telephone-plus.svg": [
		48483,
		48483
	],
	"./telephone-x-fill.svg": [
		21755,
		21755
	],
	"./telephone-x.svg": [
		61670,
		61670
	],
	"./telephone.svg": [
		47641,
		47641
	],
	"./tencent-qq.svg": [
		20292,
		20292
	],
	"./terminal-dash.svg": [
		21874,
		21874
	],
	"./terminal-fill.svg": [
		99455,
		99455
	],
	"./terminal-plus.svg": [
		56247,
		56247
	],
	"./terminal-split.svg": [
		855,
		855
	],
	"./terminal-x.svg": [
		78969,
		78969
	],
	"./terminal.svg": [
		99542,
		99542
	],
	"./text-center.svg": [
		203,
		203
	],
	"./text-indent-left.svg": [
		39872,
		39872
	],
	"./text-indent-right.svg": [
		1581,
		1581
	],
	"./text-left.svg": [
		19573,
		19573
	],
	"./text-paragraph.svg": [
		38777,
		38777
	],
	"./text-right.svg": [
		29300,
		29300
	],
	"./text-wrap.svg": [
		21788,
		21788
	],
	"./textarea-resize.svg": [
		78090,
		78090
	],
	"./textarea-t.svg": [
		85106,
		85106
	],
	"./textarea.svg": [
		82824,
		82824
	],
	"./thermometer-half.svg": [
		56043,
		56043
	],
	"./thermometer-high.svg": [
		74641,
		74641
	],
	"./thermometer-low.svg": [
		42713,
		42713
	],
	"./thermometer-snow.svg": [
		95877,
		95877
	],
	"./thermometer-sun.svg": [
		81083,
		81083
	],
	"./thermometer.svg": [
		72351,
		72351
	],
	"./threads-fill.svg": [
		81494,
		81494
	],
	"./threads.svg": [
		39095,
		39095
	],
	"./three-dots-vertical.svg": [
		66170,
		66170
	],
	"./three-dots.svg": [
		4704,
		4704
	],
	"./thunderbolt-fill.svg": [
		40924,
		40924
	],
	"./thunderbolt.svg": [
		15236,
		15236
	],
	"./ticket-detailed-fill.svg": [
		90844,
		90844
	],
	"./ticket-detailed.svg": [
		85963,
		85963
	],
	"./ticket-fill.svg": [
		19580,
		19580
	],
	"./ticket-perforated-fill.svg": [
		12420,
		12420
	],
	"./ticket-perforated.svg": [
		68606,
		68606
	],
	"./ticket.svg": [
		65750,
		65750
	],
	"./tiktok.svg": [
		46339,
		46339
	],
	"./toggle-off.svg": [
		8246,
		8246
	],
	"./toggle-on.svg": [
		32073,
		32073
	],
	"./toggle2-off.svg": [
		18206,
		18206
	],
	"./toggle2-on.svg": [
		89948,
		89948
	],
	"./toggles.svg": [
		10096,
		10096
	],
	"./toggles2.svg": [
		51601,
		51601
	],
	"./tools.svg": [
		68607,
		68607
	],
	"./tornado.svg": [
		17775,
		17775
	],
	"./train-freight-front-fill.svg": [
		69224,
		69224
	],
	"./train-freight-front.svg": [
		12453,
		12453
	],
	"./train-front-fill.svg": [
		93489,
		93489
	],
	"./train-front.svg": [
		80394,
		80394
	],
	"./train-lightrail-front-fill.svg": [
		38869,
		38869
	],
	"./train-lightrail-front.svg": [
		97516,
		97516
	],
	"./translate.svg": [
		87115,
		87115
	],
	"./transparency.svg": [
		2136,
		95770
	],
	"./trash-fill.svg": [
		6631,
		6631
	],
	"./trash.svg": [
		8949,
		92509
	],
	"./trash2-fill.svg": [
		72169,
		72169
	],
	"./trash2.svg": [
		54885,
		54885
	],
	"./trash3-fill.svg": [
		78136,
		78136
	],
	"./trash3.svg": [
		47328,
		47328
	],
	"./tree-fill.svg": [
		69906,
		69906
	],
	"./tree.svg": [
		69272,
		69272
	],
	"./trello.svg": [
		58452,
		9468
	],
	"./triangle-fill.svg": [
		90542,
		90542
	],
	"./triangle-half.svg": [
		97081,
		97081
	],
	"./triangle.svg": [
		21166,
		21166
	],
	"./trophy-fill.svg": [
		71741,
		71741
	],
	"./trophy.svg": [
		97083,
		97083
	],
	"./tropical-storm.svg": [
		58967,
		58967
	],
	"./truck-flatbed.svg": [
		54904,
		54904
	],
	"./truck-front-fill.svg": [
		82443,
		82443
	],
	"./truck-front.svg": [
		84226,
		84226
	],
	"./truck.svg": [
		59651,
		59651
	],
	"./tsunami.svg": [
		89261,
		89261
	],
	"./tv-fill.svg": [
		32362,
		32362
	],
	"./tv.svg": [
		75609,
		75609
	],
	"./twitch.svg": [
		23662,
		23662
	],
	"./twitter-x.svg": [
		79979,
		79979
	],
	"./twitter.svg": [
		14845,
		14845
	],
	"./type-bold.svg": [
		43818,
		43818
	],
	"./type-h1.svg": [
		72469,
		72469
	],
	"./type-h2.svg": [
		50907,
		50907
	],
	"./type-h3.svg": [
		84448,
		84448
	],
	"./type-h4.svg": [
		89617,
		89617
	],
	"./type-h5.svg": [
		36362,
		36362
	],
	"./type-h6.svg": [
		25788,
		25788
	],
	"./type-italic.svg": [
		69406,
		69406
	],
	"./type-strikethrough.svg": [
		10749,
		10749
	],
	"./type-underline.svg": [
		29595,
		29595
	],
	"./type.svg": [
		7651,
		7651
	],
	"./ubuntu.svg": [
		91193,
		91193
	],
	"./ui-checks-grid.svg": [
		59010,
		59010
	],
	"./ui-checks.svg": [
		32316,
		32316
	],
	"./ui-radios-grid.svg": [
		96769,
		96769
	],
	"./ui-radios.svg": [
		59646,
		59646
	],
	"./umbrella-fill.svg": [
		47138,
		47138
	],
	"./umbrella.svg": [
		35101,
		35101
	],
	"./unindent.svg": [
		57789,
		57789
	],
	"./union.svg": [
		64889,
		64889
	],
	"./unity.svg": [
		51518,
		51518
	],
	"./universal-access-circle.svg": [
		95666,
		95666
	],
	"./universal-access.svg": [
		24677,
		24677
	],
	"./unlock-fill.svg": [
		24082,
		24082
	],
	"./unlock.svg": [
		37196,
		37196
	],
	"./upc-scan.svg": [
		23237,
		23237
	],
	"./upc.svg": [
		27941,
		27941
	],
	"./upload.svg": [
		67561,
		67561
	],
	"./usb-c-fill.svg": [
		83653,
		83653
	],
	"./usb-c.svg": [
		89306,
		89306
	],
	"./usb-drive-fill.svg": [
		34280,
		34280
	],
	"./usb-drive.svg": [
		43091,
		43091
	],
	"./usb-fill.svg": [
		83464,
		83464
	],
	"./usb-micro-fill.svg": [
		56883,
		56883
	],
	"./usb-micro.svg": [
		85640,
		85640
	],
	"./usb-mini-fill.svg": [
		59528,
		59528
	],
	"./usb-mini.svg": [
		40178,
		40178
	],
	"./usb-plug-fill.svg": [
		47592,
		47592
	],
	"./usb-plug.svg": [
		47764,
		47764
	],
	"./usb-symbol.svg": [
		86391,
		86391
	],
	"./usb.svg": [
		17725,
		17725
	],
	"./valentine.svg": [
		36243,
		36243
	],
	"./valentine2.svg": [
		34821,
		34821
	],
	"./vector-pen.svg": [
		15281,
		15281
	],
	"./view-list.svg": [
		6774,
		6774
	],
	"./view-stacked.svg": [
		96604,
		96604
	],
	"./vignette.svg": [
		7817,
		7817
	],
	"./vimeo.svg": [
		67584,
		67584
	],
	"./vinyl-fill.svg": [
		23996,
		23996
	],
	"./vinyl.svg": [
		40839,
		40839
	],
	"./virus.svg": [
		2915,
		2915
	],
	"./virus2.svg": [
		60902,
		60902
	],
	"./voicemail.svg": [
		83105,
		83105
	],
	"./volume-down-fill.svg": [
		86375,
		86375
	],
	"./volume-down.svg": [
		23305,
		23305
	],
	"./volume-mute-fill.svg": [
		65127,
		65127
	],
	"./volume-mute.svg": [
		1855,
		1855
	],
	"./volume-off-fill.svg": [
		10738,
		10738
	],
	"./volume-off.svg": [
		49395,
		49395
	],
	"./volume-up-fill.svg": [
		60413,
		60413
	],
	"./volume-up.svg": [
		63105,
		63105
	],
	"./vr.svg": [
		52240,
		52240
	],
	"./wallet-fill.svg": [
		98237,
		98237
	],
	"./wallet.svg": [
		86533,
		86533
	],
	"./wallet2.svg": [
		42995,
		42995
	],
	"./watch.svg": [
		76950,
		76950
	],
	"./water.svg": [
		76650,
		76650
	],
	"./webcam-fill.svg": [
		87950,
		87950
	],
	"./webcam.svg": [
		60280,
		60280
	],
	"./wechat.svg": [
		99674,
		99674
	],
	"./whatsapp.svg": [
		12125,
		12125
	],
	"./wifi-1.svg": [
		48229,
		48229
	],
	"./wifi-2.svg": [
		12099,
		12099
	],
	"./wifi-off.svg": [
		24004,
		24004
	],
	"./wifi.svg": [
		41268,
		41268
	],
	"./wikipedia.svg": [
		48310,
		48310
	],
	"./wind.svg": [
		75973,
		75973
	],
	"./window-dash.svg": [
		68769,
		68769
	],
	"./window-desktop.svg": [
		12243,
		12243
	],
	"./window-dock.svg": [
		73956,
		1873
	],
	"./window-fullscreen.svg": [
		15744,
		15744
	],
	"./window-plus.svg": [
		46754,
		46754
	],
	"./window-sidebar.svg": [
		92472,
		92472
	],
	"./window-split.svg": [
		17389,
		17389
	],
	"./window-stack.svg": [
		78426,
		78426
	],
	"./window-x.svg": [
		76391,
		76391
	],
	"./window.svg": [
		40278,
		40278
	],
	"./windows.svg": [
		51947,
		51947
	],
	"./wordpress.svg": [
		29728,
		29728
	],
	"./wrench-adjustable-circle-fill.svg": [
		25277,
		25277
	],
	"./wrench-adjustable-circle.svg": [
		10804,
		10804
	],
	"./wrench-adjustable.svg": [
		81946,
		81946
	],
	"./wrench.svg": [
		59726,
		59726
	],
	"./x-circle-fill.svg": [
		47280,
		47280
	],
	"./x-circle.svg": [
		93377,
		93377
	],
	"./x-diamond-fill.svg": [
		36727,
		36727
	],
	"./x-diamond.svg": [
		34242,
		34242
	],
	"./x-lg.svg": [
		74023,
		74023
	],
	"./x-octagon-fill.svg": [
		2043,
		2043
	],
	"./x-octagon.svg": [
		20340,
		20340
	],
	"./x-square-fill.svg": [
		28147,
		28147
	],
	"./x-square.svg": [
		57060,
		57060
	],
	"./x.svg": [
		10956,
		10956
	],
	"./xbox.svg": [
		27564,
		27564
	],
	"./yelp.svg": [
		38911,
		38911
	],
	"./yin-yang.svg": [
		86558,
		86558
	],
	"./youtube.svg": [
		44420,
		44420
	],
	"./zoom-in.svg": [
		44021,
		44021
	],
	"./zoom-out.svg": [
		70498,
		70498
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 47010;
module.exports = webpackAsyncContext;